import { toString as toString_2, Record, Union } from "../../../../iotpool-front3/src/fable_modules/fable-library-js.4.24.0/Types.js";
import { enum_type, class_type, list_type, record_type, option_type, bool_type, string_type, int32_type, float64_type, union_type } from "../../../../iotpool-front3/src/fable_modules/fable-library-js.4.24.0/Reflection.js";
import { length, ofArray, map, singleton, toArray, append, empty } from "../../../../iotpool-front3/src/fable_modules/fable-library-js.4.24.0/List.js";
import { some, defaultArg, value as value_247 } from "../../../../iotpool-front3/src/fable_modules/fable-library-js.4.24.0/Option.js";
import { now, toString as toString_1 } from "../../../../iotpool-front3/src/fable_modules/fable-library-js.4.24.0/Date.js";
import { uncurry3, uncurry2, createObj } from "../../../../iotpool-front3/src/fable_modules/fable-library-js.4.24.0/Util.js";
import { option as option_101, datetime as datetime_1, list as list_6, nil, object, toString as toString_3 } from "../../../../iotpool-front3/src/fable_modules/Thoth.Json.7.0.0/Encode.fs.js";
import { datetime, fail, succeed, andThen, list as list_7, int, float, bool, option as option_100, string, object as object_1 } from "../../../../iotpool-front3/src/fable_modules/Thoth.Json.7.0.0/Decode.fs.js";
import { join, toConsole, printf, toText } from "../../../../iotpool-front3/src/fable_modules/fable-library-js.4.24.0/String.js";

export class Encoder_FieldCheck extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Required", "Optional"];
    }
}

export function Encoder_FieldCheck_$reflection() {
    return union_type("Iotpool.Dotnet.Encoder.FieldCheck", [], Encoder_FieldCheck, () => [[], []]);
}

export const Encoder_dateFormat = "yyyy-MM-ddTHH:mm:ssZ";

export const Encoder_empty = empty();

export function Encoder_simpleList(label, l, input) {
    return append(input, singleton([label, toArray(l)]));
}

export function Encoder_list(option, label, l, customEncoder, input) {
    if (option.tag === 0) {
        const _arg_1 = l;
        if (_arg_1 == null) {
            return append(input, singleton([label, undefined]));
        }
        else {
            const c_1 = _arg_1;
            if (customEncoder == null) {
                return append(input, singleton([label, toArray(c_1)]));
            }
            else {
                return append(input, singleton([label, toArray(map(customEncoder, c_1))]));
            }
        }
    }
    else {
        const _arg = l;
        if (_arg == null) {
            return input;
        }
        else {
            const c = _arg;
            if (customEncoder == null) {
                return append(input, singleton([label, toArray(c)]));
            }
            else {
                return append(input, singleton([label, toArray(map(customEncoder, c))]));
            }
        }
    }
}

export function Encoder_custom(label, a, input) {
    if (a == null) {
        return input;
    }
    else {
        return append(input, singleton([label, value_247(a)]));
    }
}

export function Encoder_object(option, label, a, input) {
    if (option.tag === 0) {
        const _arg_1 = a;
        if (_arg_1 == null) {
            return append(input, singleton([label, undefined]));
        }
        else {
            return append(input, singleton([label, value_247(_arg_1)]));
        }
    }
    else {
        const _arg = a;
        if (_arg == null) {
            return input;
        }
        else {
            return append(input, singleton([label, value_247(_arg)]));
        }
    }
}

export function Encoder_date(option, label, a, input) {
    const toString = (date) => toString_1(date, Encoder_dateFormat);
    if (option.tag === 0) {
        const _arg_1 = a;
        if (_arg_1 == null) {
            return append(input, singleton([label, undefined]));
        }
        else {
            return append(input, singleton([label, toString(_arg_1)]));
        }
    }
    else {
        const _arg = a;
        if (_arg == null) {
            return input;
        }
        else {
            return append(input, singleton([label, toString(_arg)]));
        }
    }
}

export function Encoder_string(option, label, a, input) {
    if (option.tag === 0) {
        const _arg_1 = a;
        if (_arg_1 == null) {
            return append(input, singleton([label, undefined]));
        }
        else {
            return append(input, singleton([label, _arg_1]));
        }
    }
    else {
        const _arg = a;
        if (_arg == null) {
            return input;
        }
        else {
            return append(input, singleton([label, _arg]));
        }
    }
}

export function Encoder_int(option, label, a, input) {
    if (option.tag === 0) {
        const _arg_1 = a;
        if (_arg_1 == null) {
            return append(input, singleton([label, undefined]));
        }
        else {
            return append(input, singleton([label, _arg_1]));
        }
    }
    else {
        const _arg = a;
        if (_arg == null) {
            return input;
        }
        else {
            return append(input, singleton([label, _arg]));
        }
    }
}

export function Encoder_float(option, label, a, input) {
    if (option.tag === 0) {
        const _arg_1 = a;
        if (_arg_1 == null) {
            return append(input, singleton([label, undefined]));
        }
        else {
            return append(input, singleton([label, _arg_1]));
        }
    }
    else {
        const _arg = a;
        if (_arg == null) {
            return input;
        }
        else {
            return append(input, singleton([label, _arg]));
        }
    }
}

export function Encoder_bool(option, label, a, input) {
    if (option.tag === 0) {
        const _arg_1 = a;
        if (_arg_1 == null) {
            return append(input, singleton([label, undefined]));
        }
        else {
            return append(input, singleton([label, _arg_1]));
        }
    }
    else {
        const _arg = a;
        if (_arg == null) {
            return input;
        }
        else {
            return append(input, singleton([label, _arg]));
        }
    }
}

export function Encoder_toPlainJsObj(input) {
    return createObj(input);
}

export class Types_AlarmSpace extends Record {
    constructor(Last, Duration, DocKind, Id, Deleted, Rev) {
        super();
        this.Last = Last;
        this.Duration = (Duration | 0);
        this.DocKind = DocKind;
        this.Id = Id;
        this.Deleted = Deleted;
        this.Rev = Rev;
    }
}

export function Types_AlarmSpace_$reflection() {
    return record_type("Iotpool.Dotnet.Types.AlarmSpace", [], Types_AlarmSpace, () => [["Last", float64_type], ["Duration", int32_type], ["DocKind", Types_DocKind_$reflection()], ["Id", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)]]);
}

export class Types_LoiDeChauffe extends Record {
    constructor(EtalonId, Pente, TemperatureAmbiance, TemperatureMinDepart, TemperatureMaxDepart, TemperatureMinExterieure, TemperatureMaxExterieure, PenteNuit, TemperatureMinDepartNuit, TemperatureMaxDepartNuit, TemperatureMinExterieureNuit, TemperatureMaxExterieureNuit, Schedule, MinDay, MaxDay, MinNight, MaxNight) {
        super();
        this.EtalonId = EtalonId;
        this.Pente = Pente;
        this.TemperatureAmbiance = TemperatureAmbiance;
        this.TemperatureMinDepart = TemperatureMinDepart;
        this.TemperatureMaxDepart = TemperatureMaxDepart;
        this.TemperatureMinExterieure = TemperatureMinExterieure;
        this.TemperatureMaxExterieure = TemperatureMaxExterieure;
        this.PenteNuit = PenteNuit;
        this.TemperatureMinDepartNuit = TemperatureMinDepartNuit;
        this.TemperatureMaxDepartNuit = TemperatureMaxDepartNuit;
        this.TemperatureMinExterieureNuit = TemperatureMinExterieureNuit;
        this.TemperatureMaxExterieureNuit = TemperatureMaxExterieureNuit;
        this.Schedule = Schedule;
        this.MinDay = MinDay;
        this.MaxDay = MaxDay;
        this.MinNight = MinNight;
        this.MaxNight = MaxNight;
    }
}

export function Types_LoiDeChauffe_$reflection() {
    return record_type("Iotpool.Dotnet.Types.LoiDeChauffe", [], Types_LoiDeChauffe, () => [["EtalonId", option_type(string_type)], ["Pente", option_type(float64_type)], ["TemperatureAmbiance", option_type(float64_type)], ["TemperatureMinDepart", option_type(float64_type)], ["TemperatureMaxDepart", option_type(float64_type)], ["TemperatureMinExterieure", option_type(float64_type)], ["TemperatureMaxExterieure", option_type(float64_type)], ["PenteNuit", option_type(float64_type)], ["TemperatureMinDepartNuit", option_type(float64_type)], ["TemperatureMaxDepartNuit", option_type(float64_type)], ["TemperatureMinExterieureNuit", option_type(float64_type)], ["TemperatureMaxExterieureNuit", option_type(float64_type)], ["Schedule", option_type(list_type(Types_ScheduleDay_$reflection()))], ["MinDay", option_type(float64_type)], ["MaxDay", option_type(float64_type)], ["MinNight", option_type(float64_type)], ["MaxNight", option_type(float64_type)]]);
}

export class Types_DocKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["User", "Module", "Account", "Tag", "Sensor", "Contract", "Alarm", "AlarmSpace"];
    }
}

export function Types_DocKind_$reflection() {
    return union_type("Iotpool.Dotnet.Types.DocKind", [], Types_DocKind, () => [[], [], [], [], [], [], [], []]);
}

export class Types_ProbeKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TC", "EVA", "ECVA", "CO2", "REDOX", "CTN", "V010", "V0420", "TCK", "Hygro", "Conductivity", "Battery", "Ultrasound", "Impulsion", "Impulsion1L", "Impulsion10L", "Contact", "Pression", "Irradiation", "Rssi", "Cumulated", "WIND", "SPEED", "RAIN", "PYRANOMETER"];
    }
}

export function Types_ProbeKind_$reflection() {
    return union_type("Iotpool.Dotnet.Types.ProbeKind", [], Types_ProbeKind, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class Types_SensorKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TEST", "IOT3CTN", "IOTCTN2", "IOT2CTN", "IOT2CTN10", "IOT2CTN100", "THERMOK", "IOCPV", "IOT3000PA", "IOTIMPULSE", "M19SOLA", "M25ULTRASOUND", "ULSA", "LIQ", "M32", "CO2", "CONTACTS2", "REDOX", "VA", "TRIVA", "THI", "SYSTEM", "TH", "T", "IOTV010", "IOTPHY", "METEO", "IOTV0420", "IOTV010420", "IOT010P", "IOT2T1C", "SIGFOXTEST", "LORAT", "LORA2T1P", "LORA2T1C", "LORACO2", "LORATH", "LORA3CTN", "LORA2CTN", "LORA2TCK", "IOT2P", "LORA2P", "COV", "PT100", "GENERIC010420"];
    }
}

export function Types_SensorKind_$reflection() {
    return union_type("Iotpool.Dotnet.Types.SensorKind", [], Types_SensorKind, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class Types_Token extends Record {
    constructor(Read, Write) {
        super();
        this.Read = Read;
        this.Write = Write;
    }
}

export function Types_Token_$reflection() {
    return record_type("Iotpool.Dotnet.Types.Token", [], Types_Token, () => [["Read", string_type], ["Write", string_type]]);
}

export class Types_Contract extends Record {
    constructor(Id, Deleted, Rev, DocKind, Name, MaxActiveSeries, Token, Server) {
        super();
        this.Id = Id;
        this.Deleted = Deleted;
        this.Rev = Rev;
        this.DocKind = DocKind;
        this.Name = Name;
        this.MaxActiveSeries = (MaxActiveSeries | 0);
        this.Token = Token;
        this.Server = Server;
    }
}

export function Types_Contract_$reflection() {
    return record_type("Iotpool.Dotnet.Types.Contract", [], Types_Contract, () => [["Id", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)], ["DocKind", Types_DocKind_$reflection()], ["Name", string_type], ["MaxActiveSeries", int32_type], ["Token", Types_Token_$reflection()], ["Server", option_type(string_type)]]);
}

export class Types_CalibrationOperation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Plus", "Minus"];
    }
}

export function Types_CalibrationOperation_$reflection() {
    return union_type("Iotpool.Dotnet.Types.CalibrationOperation", [], Types_CalibrationOperation, () => [[], []]);
}

export class Types_Calibration extends Record {
    constructor(Date$, Value, Operation) {
        super();
        this.Date = Date$;
        this.Value = Value;
        this.Operation = Operation;
    }
}

export function Types_Calibration_$reflection() {
    return record_type("Iotpool.Dotnet.Types.Calibration", [], Types_Calibration, () => [["Date", class_type("System.DateTime")], ["Value", float64_type], ["Operation", Types_CalibrationOperation_$reflection()]]);
}

export class Types_Interpolation extends Record {
    constructor(Zero, Max, Range$, Unit) {
        super();
        this.Zero = Zero;
        this.Max = Max;
        this.Range = Range$;
        this.Unit = Unit;
    }
}

export function Types_Interpolation_$reflection() {
    return record_type("Iotpool.Dotnet.Types.Interpolation", [], Types_Interpolation, () => [["Zero", float64_type], ["Max", float64_type], ["Range", float64_type], ["Unit", string_type]]);
}

export class Types_Coeff extends Record {
    constructor(Coeff, Unit) {
        super();
        this.Coeff = Coeff;
        this.Unit = Unit;
    }
}

export function Types_Coeff_$reflection() {
    return record_type("Iotpool.Dotnet.Types.Coeff", [], Types_Coeff, () => [["Coeff", float64_type], ["Unit", string_type]]);
}

export class Types_SensorOption extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ALARMSCHEDULER", "APISHARE", "SMS", "VOICE", "ALARMOFF", "LDC", "BACKTOWORK", "APLUS", "APLUSSMS", "APLUSVOICE", "APLUSMAX"];
    }
}

export function Types_SensorOption_$reflection() {
    return union_type("Iotpool.Dotnet.Types.SensorOption", [], Types_SensorOption, () => [[], [], [], [], [], [], [], [], [], [], []]);
}

export class Types_ScheduleDay extends Record {
    constructor(Hour, Day) {
        super();
        this.Hour = (Hour | 0);
        this.Day = (Day | 0);
    }
}

export function Types_ScheduleDay_$reflection() {
    return record_type("Iotpool.Dotnet.Types.ScheduleDay", [], Types_ScheduleDay, () => [["Hour", int32_type], ["Day", enum_type("System.DayOfWeek", int32_type, [["Sunday", 0], ["Monday", 1], ["Tuesday", 2], ["Wednesday", 3], ["Thursday", 4], ["Friday", 5], ["Saturday", 6]])]]);
}

export class Types_AlarmSettings extends Record {
    constructor(Min, Max) {
        super();
        this.Min = Min;
        this.Max = Max;
    }
}

export function Types_AlarmSettings_$reflection() {
    return record_type("Iotpool.Dotnet.Types.AlarmSettings", [], Types_AlarmSettings, () => [["Min", option_type(float64_type)], ["Max", option_type(float64_type)]]);
}

export class Types_CumulParameters extends Record {
    constructor(ResetCumul, CumulIndex, LastUpdate) {
        super();
        this.ResetCumul = ResetCumul;
        this.CumulIndex = (CumulIndex | 0);
        this.LastUpdate = LastUpdate;
    }
}

export function Types_CumulParameters_$reflection() {
    return record_type("Iotpool.Dotnet.Types.CumulParameters", [], Types_CumulParameters, () => [["ResetCumul", bool_type], ["CumulIndex", int32_type], ["LastUpdate", option_type(class_type("System.DateTime"))]]);
}

export class Types_Alarm extends Record {
    constructor(S1, S2, S3, S4, S5, S6, S7, S8, S9, S10, Activate, Emails, Tels, TelsForVoice, Battery, MaxSMSPerDay, SmsCount, VoiceCount, EmailCount, SmsSent, DelayInterval, IgnoreInterval, Ignore) {
        super();
        this.S1 = S1;
        this.S2 = S2;
        this.S3 = S3;
        this.S4 = S4;
        this.S5 = S5;
        this.S6 = S6;
        this.S7 = S7;
        this.S8 = S8;
        this.S9 = S9;
        this.S10 = S10;
        this.Activate = Activate;
        this.Emails = Emails;
        this.Tels = Tels;
        this.TelsForVoice = TelsForVoice;
        this.Battery = Battery;
        this.MaxSMSPerDay = MaxSMSPerDay;
        this.SmsCount = (SmsCount | 0);
        this.VoiceCount = VoiceCount;
        this.EmailCount = EmailCount;
        this.SmsSent = SmsSent;
        this.DelayInterval = (DelayInterval | 0);
        this.IgnoreInterval = IgnoreInterval;
        this.Ignore = Ignore;
    }
}

export function Types_Alarm_$reflection() {
    return record_type("Iotpool.Dotnet.Types.Alarm", [], Types_Alarm, () => [["S1", option_type(Types_AlarmSettings_$reflection())], ["S2", option_type(Types_AlarmSettings_$reflection())], ["S3", option_type(Types_AlarmSettings_$reflection())], ["S4", option_type(Types_AlarmSettings_$reflection())], ["S5", option_type(Types_AlarmSettings_$reflection())], ["S6", option_type(Types_AlarmSettings_$reflection())], ["S7", option_type(Types_AlarmSettings_$reflection())], ["S8", option_type(Types_AlarmSettings_$reflection())], ["S9", option_type(Types_AlarmSettings_$reflection())], ["S10", option_type(Types_AlarmSettings_$reflection())], ["Activate", bool_type], ["Emails", option_type(list_type(string_type))], ["Tels", option_type(list_type(string_type))], ["TelsForVoice", option_type(list_type(string_type))], ["Battery", option_type(Types_AlarmSettings_$reflection())], ["MaxSMSPerDay", option_type(int32_type)], ["SmsCount", int32_type], ["VoiceCount", option_type(int32_type)], ["EmailCount", option_type(int32_type)], ["SmsSent", option_type(list_type(string_type))], ["DelayInterval", int32_type], ["IgnoreInterval", option_type(int32_type)], ["Ignore", option_type(bool_type)]]);
}

export class Types_Full extends Record {
    constructor(Id, Deleted, Rev, DocKind, SensorKind, Name, Contract, Title, S1, S2, S3, S4, S5, S6, S7, S8, S9, S10, S1Title, S2Title, S3Title, S4Title, S5Title, S6Title, S7Title, S8Title, S9Title, S10Title, S1Activated, S2Activated, S3Activated, S4Activated, S5Activated, S6Activated, S7Activated, S8Activated, S9Activated, S10Activated, S1Calibration, S2Calibration, S3Calibration, S4Calibration, S5Calibration, S6Calibration, S7Calibration, S8Calibration, S9Calibration, S10Calibration, S1Interpolation, S2Interpolation, S3Interpolation, S4Interpolation, S5Interpolation, S6Interpolation, S7Interpolation, S8Interpolation, S9Interpolation, S10Interpolation, S1Coeff, S2Coeff, S3Coeff, S4Coeff, S5Coeff, S6Coeff, S7Coeff, S8Coeff, S9Coeff, S10Coeff, S1CumulParameters, S2CumulParameters, S3CumulParameters, S4CumulParameters, S5CumulParameters, S6CumulParameters, S7CumulParameters, S8CumulParameters, S9CumulParameters, S10CumulParameters, OwnerWeb, OwnerName, Alarm, WriteAccess, LastCall, ShareKey, ShareCode, SharePass, Schedule, SensorOptions, IsBackToWork, ResumeWork, Birthday, EndOfLife, Cumulated, TwimmCall, TwimmToken, VAKind, EtalonLDC, Ldcv2, LoiDeChauffe, CheckPowerLoss, RenewalInterval, CheckedWeeks, IsBeta, IsDead, Tag) {
        super();
        this.Id = Id;
        this.Deleted = Deleted;
        this.Rev = Rev;
        this.DocKind = DocKind;
        this.SensorKind = SensorKind;
        this.Name = Name;
        this.Contract = Contract;
        this.Title = Title;
        this.S1 = S1;
        this.S2 = S2;
        this.S3 = S3;
        this.S4 = S4;
        this.S5 = S5;
        this.S6 = S6;
        this.S7 = S7;
        this.S8 = S8;
        this.S9 = S9;
        this.S10 = S10;
        this.S1Title = S1Title;
        this.S2Title = S2Title;
        this.S3Title = S3Title;
        this.S4Title = S4Title;
        this.S5Title = S5Title;
        this.S6Title = S6Title;
        this.S7Title = S7Title;
        this.S8Title = S8Title;
        this.S9Title = S9Title;
        this.S10Title = S10Title;
        this.S1Activated = S1Activated;
        this.S2Activated = S2Activated;
        this.S3Activated = S3Activated;
        this.S4Activated = S4Activated;
        this.S5Activated = S5Activated;
        this.S6Activated = S6Activated;
        this.S7Activated = S7Activated;
        this.S8Activated = S8Activated;
        this.S9Activated = S9Activated;
        this.S10Activated = S10Activated;
        this.S1Calibration = S1Calibration;
        this.S2Calibration = S2Calibration;
        this.S3Calibration = S3Calibration;
        this.S4Calibration = S4Calibration;
        this.S5Calibration = S5Calibration;
        this.S6Calibration = S6Calibration;
        this.S7Calibration = S7Calibration;
        this.S8Calibration = S8Calibration;
        this.S9Calibration = S9Calibration;
        this.S10Calibration = S10Calibration;
        this.S1Interpolation = S1Interpolation;
        this.S2Interpolation = S2Interpolation;
        this.S3Interpolation = S3Interpolation;
        this.S4Interpolation = S4Interpolation;
        this.S5Interpolation = S5Interpolation;
        this.S6Interpolation = S6Interpolation;
        this.S7Interpolation = S7Interpolation;
        this.S8Interpolation = S8Interpolation;
        this.S9Interpolation = S9Interpolation;
        this.S10Interpolation = S10Interpolation;
        this.S1Coeff = S1Coeff;
        this.S2Coeff = S2Coeff;
        this.S3Coeff = S3Coeff;
        this.S4Coeff = S4Coeff;
        this.S5Coeff = S5Coeff;
        this.S6Coeff = S6Coeff;
        this.S7Coeff = S7Coeff;
        this.S8Coeff = S8Coeff;
        this.S9Coeff = S9Coeff;
        this.S10Coeff = S10Coeff;
        this.S1CumulParameters = S1CumulParameters;
        this.S2CumulParameters = S2CumulParameters;
        this.S3CumulParameters = S3CumulParameters;
        this.S4CumulParameters = S4CumulParameters;
        this.S5CumulParameters = S5CumulParameters;
        this.S6CumulParameters = S6CumulParameters;
        this.S7CumulParameters = S7CumulParameters;
        this.S8CumulParameters = S8CumulParameters;
        this.S9CumulParameters = S9CumulParameters;
        this.S10CumulParameters = S10CumulParameters;
        this.OwnerWeb = OwnerWeb;
        this.OwnerName = OwnerName;
        this.Alarm = Alarm;
        this.WriteAccess = WriteAccess;
        this.LastCall = LastCall;
        this.ShareKey = ShareKey;
        this.ShareCode = ShareCode;
        this.SharePass = SharePass;
        this.Schedule = Schedule;
        this.SensorOptions = SensorOptions;
        this.IsBackToWork = IsBackToWork;
        this.ResumeWork = ResumeWork;
        this.Birthday = Birthday;
        this.EndOfLife = EndOfLife;
        this.Cumulated = Cumulated;
        this.TwimmCall = TwimmCall;
        this.TwimmToken = TwimmToken;
        this.VAKind = VAKind;
        this.EtalonLDC = EtalonLDC;
        this.Ldcv2 = Ldcv2;
        this.LoiDeChauffe = LoiDeChauffe;
        this.CheckPowerLoss = CheckPowerLoss;
        this.RenewalInterval = RenewalInterval;
        this.CheckedWeeks = CheckedWeeks;
        this.IsBeta = IsBeta;
        this.IsDead = IsDead;
        this.Tag = Tag;
    }
}

export function Types_Full_$reflection() {
    return record_type("Iotpool.Dotnet.Types.Full", [], Types_Full, () => [["Id", string_type], ["Deleted", option_type(bool_type)], ["Rev", option_type(string_type)], ["DocKind", Types_DocKind_$reflection()], ["SensorKind", Types_SensorKind_$reflection()], ["Name", string_type], ["Contract", string_type], ["Title", option_type(string_type)], ["S1", option_type(Types_ProbeKind_$reflection())], ["S2", option_type(Types_ProbeKind_$reflection())], ["S3", option_type(Types_ProbeKind_$reflection())], ["S4", option_type(Types_ProbeKind_$reflection())], ["S5", option_type(Types_ProbeKind_$reflection())], ["S6", option_type(Types_ProbeKind_$reflection())], ["S7", option_type(Types_ProbeKind_$reflection())], ["S8", option_type(Types_ProbeKind_$reflection())], ["S9", option_type(Types_ProbeKind_$reflection())], ["S10", option_type(Types_ProbeKind_$reflection())], ["S1Title", option_type(string_type)], ["S2Title", option_type(string_type)], ["S3Title", option_type(string_type)], ["S4Title", option_type(string_type)], ["S5Title", option_type(string_type)], ["S6Title", option_type(string_type)], ["S7Title", option_type(string_type)], ["S8Title", option_type(string_type)], ["S9Title", option_type(string_type)], ["S10Title", option_type(string_type)], ["S1Activated", option_type(bool_type)], ["S2Activated", option_type(bool_type)], ["S3Activated", option_type(bool_type)], ["S4Activated", option_type(bool_type)], ["S5Activated", option_type(bool_type)], ["S6Activated", option_type(bool_type)], ["S7Activated", option_type(bool_type)], ["S8Activated", option_type(bool_type)], ["S9Activated", option_type(bool_type)], ["S10Activated", option_type(bool_type)], ["S1Calibration", option_type(Types_Calibration_$reflection())], ["S2Calibration", option_type(Types_Calibration_$reflection())], ["S3Calibration", option_type(Types_Calibration_$reflection())], ["S4Calibration", option_type(Types_Calibration_$reflection())], ["S5Calibration", option_type(Types_Calibration_$reflection())], ["S6Calibration", option_type(Types_Calibration_$reflection())], ["S7Calibration", option_type(Types_Calibration_$reflection())], ["S8Calibration", option_type(Types_Calibration_$reflection())], ["S9Calibration", option_type(Types_Calibration_$reflection())], ["S10Calibration", option_type(Types_Calibration_$reflection())], ["S1Interpolation", option_type(Types_Interpolation_$reflection())], ["S2Interpolation", option_type(Types_Interpolation_$reflection())], ["S3Interpolation", option_type(Types_Interpolation_$reflection())], ["S4Interpolation", option_type(Types_Interpolation_$reflection())], ["S5Interpolation", option_type(Types_Interpolation_$reflection())], ["S6Interpolation", option_type(Types_Interpolation_$reflection())], ["S7Interpolation", option_type(Types_Interpolation_$reflection())], ["S8Interpolation", option_type(Types_Interpolation_$reflection())], ["S9Interpolation", option_type(Types_Interpolation_$reflection())], ["S10Interpolation", option_type(Types_Interpolation_$reflection())], ["S1Coeff", option_type(Types_Coeff_$reflection())], ["S2Coeff", option_type(Types_Coeff_$reflection())], ["S3Coeff", option_type(Types_Coeff_$reflection())], ["S4Coeff", option_type(Types_Coeff_$reflection())], ["S5Coeff", option_type(Types_Coeff_$reflection())], ["S6Coeff", option_type(Types_Coeff_$reflection())], ["S7Coeff", option_type(Types_Coeff_$reflection())], ["S8Coeff", option_type(Types_Coeff_$reflection())], ["S9Coeff", option_type(Types_Coeff_$reflection())], ["S10Coeff", option_type(Types_Coeff_$reflection())], ["S1CumulParameters", option_type(Types_CumulParameters_$reflection())], ["S2CumulParameters", option_type(Types_CumulParameters_$reflection())], ["S3CumulParameters", option_type(Types_CumulParameters_$reflection())], ["S4CumulParameters", option_type(Types_CumulParameters_$reflection())], ["S5CumulParameters", option_type(Types_CumulParameters_$reflection())], ["S6CumulParameters", option_type(Types_CumulParameters_$reflection())], ["S7CumulParameters", option_type(Types_CumulParameters_$reflection())], ["S8CumulParameters", option_type(Types_CumulParameters_$reflection())], ["S9CumulParameters", option_type(Types_CumulParameters_$reflection())], ["S10CumulParameters", option_type(Types_CumulParameters_$reflection())], ["OwnerWeb", option_type(string_type)], ["OwnerName", option_type(string_type)], ["Alarm", option_type(Types_Alarm_$reflection())], ["WriteAccess", option_type(bool_type)], ["LastCall", option_type(class_type("System.DateTime"))], ["ShareKey", option_type(string_type)], ["ShareCode", option_type(string_type)], ["SharePass", option_type(int32_type)], ["Schedule", option_type(list_type(Types_ScheduleDay_$reflection()))], ["SensorOptions", option_type(list_type(Types_SensorOption_$reflection()))], ["IsBackToWork", option_type(bool_type)], ["ResumeWork", option_type(bool_type)], ["Birthday", option_type(class_type("System.DateTime"))], ["EndOfLife", option_type(int32_type)], ["Cumulated", option_type(bool_type)], ["TwimmCall", option_type(string_type)], ["TwimmToken", option_type(string_type)], ["VAKind", option_type(int32_type)], ["EtalonLDC", option_type(bool_type)], ["Ldcv2", option_type(bool_type)], ["LoiDeChauffe", option_type(Types_LoiDeChauffe_$reflection())], ["CheckPowerLoss", option_type(bool_type)], ["RenewalInterval", option_type(int32_type)], ["CheckedWeeks", option_type(list_type(int32_type))], ["IsBeta", option_type(bool_type)], ["IsDead", option_type(bool_type)], ["Tag", option_type(string_type)]]);
}

export class Types_SensorData extends Record {
    constructor(ModuleId, SensorKind, S1, S2, S3, S4, S5, S6, S7, S8, S9, S10, Battery, Rssi) {
        super();
        this.ModuleId = ModuleId;
        this.SensorKind = SensorKind;
        this.S1 = S1;
        this.S2 = S2;
        this.S3 = S3;
        this.S4 = S4;
        this.S5 = S5;
        this.S6 = S6;
        this.S7 = S7;
        this.S8 = S8;
        this.S9 = S9;
        this.S10 = S10;
        this.Battery = Battery;
        this.Rssi = Rssi;
    }
}

export function Types_SensorData_$reflection() {
    return record_type("Iotpool.Dotnet.Types.SensorData", [], Types_SensorData, () => [["ModuleId", string_type], ["SensorKind", Types_SensorKind_$reflection()], ["S1", option_type(float64_type)], ["S2", option_type(float64_type)], ["S3", option_type(float64_type)], ["S4", option_type(float64_type)], ["S5", option_type(float64_type)], ["S6", option_type(float64_type)], ["S7", option_type(float64_type)], ["S8", option_type(float64_type)], ["S9", option_type(float64_type)], ["S10", option_type(float64_type)], ["Battery", float64_type], ["Rssi", float64_type]]);
}

export function Types_AlarmSpace_Encode_53CA0639(o) {
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "docKind", toString_2(o.DocKind).toUpperCase(), Encoder_float(new Encoder_FieldCheck(0, []), "last", o.Last, Encoder_int(new Encoder_FieldCheck(0, []), "duration", o.Duration, Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty)))))));
}

export function Types_AlarmSpace_EncodeForCouch_53CA0639(o) {
    const docKind = toString_2(o.DocKind).toUpperCase();
    const matchValue = o.Rev;
    const matchValue_1 = o.Deleted;
    let matchResult, rev, rev_1;
    if (matchValue == null) {
        matchResult = 2;
    }
    else if (matchValue_1 == null) {
        matchResult = 1;
        rev_1 = matchValue;
    }
    else if (matchValue_1) {
        matchResult = 0;
        rev = matchValue;
    }
    else {
        matchResult = 1;
        rev_1 = matchValue;
    }
    switch (matchResult) {
        case 0:
            return toString_3(0, object([["last", o.Last], ["duration", o.Duration], ["_id", o.Id], ["_rev", rev], ["_deleted", true], ["docKind", docKind]]));
        case 1:
            return toString_3(0, object([["last", o.Last], ["duration", o.Duration], ["_id", o.Id], ["_rev", rev_1], ["docKind", docKind]]));
        default:
            return toString_3(0, object([["last", o.Last], ["duration", o.Duration], ["_id", o.Id], ["docKind", docKind]]));
    }
}

export function Types_AlarmSpace_Create_Z721C83C5(moduleId) {
    return new Types_AlarmSpace(Date.now(), 360, new Types_DocKind(7, []), moduleId, undefined, undefined);
}

export function Types_AlarmSpace_get_Decoder() {
    return (path_6) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2, objectArg_4, objectArg_5;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("_id", string);
        const Rev = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_100(string, path_2, value_2))), undefined);
        const Deleted = defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_deleted", (path_4, value_5) => option_100(bool, path_4, value_5))), undefined);
        let DocKind;
        const objectArg_3 = get$.Required;
        DocKind = objectArg_3.Field("docKind", uncurry2(Types_Helpers_decodeDocKind));
        return new Types_AlarmSpace((objectArg_4 = get$.Required, objectArg_4.Field("last", float)), (objectArg_5 = get$.Required, objectArg_5.Field("duration", uncurry2(int))), DocKind, Id, Deleted, Rev);
    }, path_6, v));
}

export function Types_LoiDeChauffe_Encode_550040FC(o) {
    let matchValue;
    if (o == null) {
        return {};
    }
    else {
        const o_1 = o;
        return Encoder_toPlainJsObj(Encoder_float(new Encoder_FieldCheck(1, []), "maxNight", o_1.MaxNight, Encoder_float(new Encoder_FieldCheck(1, []), "minNight", o_1.MinNight, Encoder_float(new Encoder_FieldCheck(1, []), "maxDay", o_1.MaxDay, Encoder_float(new Encoder_FieldCheck(1, []), "minDay", o_1.MinDay, Encoder_list(new Encoder_FieldCheck(1, []), "schedule", (matchValue = o_1.Schedule, (matchValue != null) ? map(Types_ScheduleDay_Encode_Z57C96D89, matchValue) : undefined), undefined, Encoder_float(new Encoder_FieldCheck(1, []), "temperatureMaxExterieureNuit", o_1.TemperatureMaxExterieureNuit, Encoder_float(new Encoder_FieldCheck(1, []), "temperatureMinExterieureNuit", o_1.TemperatureMinExterieureNuit, Encoder_float(new Encoder_FieldCheck(1, []), "temperatureMaxDepartNuit", o_1.TemperatureMaxDepartNuit, Encoder_float(new Encoder_FieldCheck(1, []), "temperatureMinDepartNuit", o_1.TemperatureMinDepartNuit, Encoder_float(new Encoder_FieldCheck(1, []), "penteNuit", o_1.PenteNuit, Encoder_float(new Encoder_FieldCheck(1, []), "temperatureMaxExterieure", o_1.TemperatureMaxExterieure, Encoder_float(new Encoder_FieldCheck(1, []), "temperatureMinExterieure", o_1.TemperatureMinExterieure, Encoder_float(new Encoder_FieldCheck(1, []), "temperatureMaxDepart", o_1.TemperatureMaxDepart, Encoder_float(new Encoder_FieldCheck(1, []), "temperatureMinDepart", o_1.TemperatureMinDepart, Encoder_float(new Encoder_FieldCheck(1, []), "temperatureAmbiance", o_1.TemperatureAmbiance, Encoder_float(new Encoder_FieldCheck(1, []), "pente", o_1.Pente, Encoder_string(new Encoder_FieldCheck(1, []), "etalonId", o_1.EtalonId, Encoder_empty))))))))))))))))));
    }
}

export function Types_LoiDeChauffe_Init_Z721C83C5(etalonId) {
    return new Types_LoiDeChauffe(etalonId, 1, 19, 20, 50, -10, 20, 1, 20, 50, -10, 20, undefined, -10, -10, -10, -10);
}

export function Types_LoiDeChauffe_EncodeForCouch_550040FC(o) {
    if (o == null) {
        return nil;
    }
    else {
        const o_1 = o;
        let schedule;
        const matchValue = o_1.Schedule;
        schedule = ((matchValue == null) ? nil : list_6(map(Types_ScheduleDay_EncodeForPouch_Z57C96D89, matchValue)));
        return object([["minDay", (o_1.MinDay != null) ? value_247(o_1.MinDay) : -1], ["maxDay", (o_1.MaxDay != null) ? value_247(o_1.MaxDay) : 24], ["minNight", (o_1.MinNight != null) ? value_247(o_1.MinNight) : -1], ["maxNight", (o_1.MaxNight != null) ? value_247(o_1.MaxNight) : 24], ["pente", (o_1.Pente != null) ? value_247(o_1.Pente) : 1], ["temperatureAmbiance", (o_1.TemperatureAmbiance != null) ? value_247(o_1.TemperatureAmbiance) : 20], ["temperatureMinDepart", (o_1.TemperatureMinDepart != null) ? value_247(o_1.TemperatureMinDepart) : 20], ["temperatureMaxDepart", (o_1.TemperatureMaxDepart != null) ? value_247(o_1.TemperatureMaxDepart) : 50], ["temperatureMinExterieure", (o_1.TemperatureMinExterieure != null) ? value_247(o_1.TemperatureMinExterieure) : -10], ["temperatureMaxExterieure", (o_1.TemperatureMaxExterieure != null) ? value_247(o_1.TemperatureMaxExterieure) : 20], ["penteNuit", (o_1.PenteNuit != null) ? value_247(o_1.PenteNuit) : 1], ["temperatureMinDepartNuit", (o_1.TemperatureMinDepartNuit != null) ? value_247(o_1.TemperatureMinDepartNuit) : 20], ["temperatureMaxDepartNuit", (o_1.TemperatureMaxDepartNuit != null) ? value_247(o_1.TemperatureMaxDepartNuit) : 50], ["temperatureMinExterieureNuit", (o_1.TemperatureMinExterieureNuit != null) ? value_247(o_1.TemperatureMinExterieureNuit) : -10], ["temperatureMaxExterieureNuit", (o_1.TemperatureMaxExterieureNuit != null) ? value_247(o_1.TemperatureMaxExterieureNuit) : 20], ["schedule", schedule], ["etalonId", (o_1.EtalonId != null) ? value_247(o_1.EtalonId) : ""]]);
    }
}

export function Types_LoiDeChauffe_get_Decoder() {
    return (path_34) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8, objectArg_9, objectArg_10, objectArg_11, arg_25, decoder_13, decoder_12, objectArg_12, objectArg_13, objectArg_14, objectArg_15, objectArg_16;
        return new Types_LoiDeChauffe(defaultArg((objectArg = get$.Optional, objectArg.Field("etalonId", (path_1, value_1) => option_100(string, path_1, value_1))), undefined), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("pente", (path_3, value_4) => option_100(float, path_3, value_4))), undefined), defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("temperatureAmbiance", (path_5, value_7) => option_100(float, path_5, value_7))), undefined), defaultArg((objectArg_3 = get$.Optional, objectArg_3.Field("temperatureMinDepart", (path_7, value_10) => option_100(float, path_7, value_10))), undefined), defaultArg((objectArg_4 = get$.Optional, objectArg_4.Field("temperatureMaxDepart", (path_9, value_13) => option_100(float, path_9, value_13))), undefined), defaultArg((objectArg_5 = get$.Optional, objectArg_5.Field("temperatureMinExterieure", (path_11, value_16) => option_100(float, path_11, value_16))), undefined), defaultArg((objectArg_6 = get$.Optional, objectArg_6.Field("temperatureMaxExterieure", (path_13, value_19) => option_100(float, path_13, value_19))), undefined), defaultArg((objectArg_7 = get$.Optional, objectArg_7.Field("penteNuit", (path_15, value_22) => option_100(float, path_15, value_22))), undefined), defaultArg((objectArg_8 = get$.Optional, objectArg_8.Field("temperatureMinDepartNuit", (path_17, value_25) => option_100(float, path_17, value_25))), undefined), defaultArg((objectArg_9 = get$.Optional, objectArg_9.Field("temperatureMaxDepartNuit", (path_19, value_28) => option_100(float, path_19, value_28))), undefined), defaultArg((objectArg_10 = get$.Optional, objectArg_10.Field("temperatureMinExterieureNuit", (path_21, value_31) => option_100(float, path_21, value_31))), undefined), defaultArg((objectArg_11 = get$.Optional, objectArg_11.Field("temperatureMaxExterieureNuit", (path_23, value_34) => option_100(float, path_23, value_34))), undefined), defaultArg((arg_25 = ((decoder_13 = ((decoder_12 = Types_ScheduleDay_get_Decoder(), (path_24) => ((value_36) => list_7(uncurry2(decoder_12), path_24, value_36)))), (path_25) => ((value_37) => option_100(uncurry2(decoder_13), path_25, value_37)))), (objectArg_12 = get$.Optional, objectArg_12.Field("schedule", uncurry2(arg_25)))), undefined), defaultArg((objectArg_13 = get$.Optional, objectArg_13.Field("minDay", (path_27, value_40) => option_100(float, path_27, value_40))), undefined), defaultArg((objectArg_14 = get$.Optional, objectArg_14.Field("maxDay", (path_29, value_43) => option_100(float, path_29, value_43))), undefined), defaultArg((objectArg_15 = get$.Optional, objectArg_15.Field("minNight", (path_31, value_46) => option_100(float, path_31, value_46))), undefined), defaultArg((objectArg_16 = get$.Optional, objectArg_16.Field("maxNight", (path_33, value_49) => option_100(float, path_33, value_49))), undefined));
    }, path_34, v));
}

export function Types_ProbeKind_get_toLabel() {
    return (_arg) => ((_arg.tag === 17) ? "Pression" : ((_arg.tag === 5) ? "CTN" : ((_arg.tag === 3) ? "CO2" : ((_arg.tag === 4) ? "mV" : ((_arg.tag === 6) ? "0-10.00V" : ((_arg.tag === 7) ? "4-20mA" : ((_arg.tag === 1) ? "Energie VAh" : ((_arg.tag === 0) ? "Tension Cellule" : ((_arg.tag === 2) ? "Energie Cumulée 24h" : ((_arg.tag === 9) ? "Hygrométrie" : ((_arg.tag === 10) ? "Conductivité" : ((_arg.tag === 11) ? "Pile (V.dc)" : ((_arg.tag === 19) ? "(RSSI) Niveau de réception radio." : ((_arg.tag === 12) ? "Ultrasons" : ((_arg.tag === 13) ? "Impulsion" : ((_arg.tag === 14) ? "Impulsion" : ((_arg.tag === 15) ? "Impulsion" : ((_arg.tag === 16) ? "Contact" : ((_arg.tag === 18) ? "Irradiation" : ((_arg.tag === 20) ? "Cumul" : ((_arg.tag === 21) ? "Direction" : ((_arg.tag === 22) ? "Vitesse du vent" : ((_arg.tag === 23) ? "Pluviométrie" : ((_arg.tag === 24) ? "Pyranomètre solaire" : "TCK"))))))))))))))))))))))));
}

export function Types_ProbeKind_get_fromString() {
    return (_arg) => {
        switch (_arg) {
            case "TCK":
                return new Types_ProbeKind(8, []);
            case "PRESSION":
                return new Types_ProbeKind(17, []);
            case "CTN":
                return new Types_ProbeKind(5, []);
            case "V010":
                return new Types_ProbeKind(6, []);
            case "V0420":
                return new Types_ProbeKind(7, []);
            case "CO2":
                return new Types_ProbeKind(3, []);
            case "REDOX":
                return new Types_ProbeKind(4, []);
            case "EVA":
                return new Types_ProbeKind(1, []);
            case "TC":
                return new Types_ProbeKind(0, []);
            case "ECVA":
                return new Types_ProbeKind(2, []);
            case "HYGRO":
                return new Types_ProbeKind(9, []);
            case "CONDUCTIVITY":
                return new Types_ProbeKind(10, []);
            case "BATTERY":
                return new Types_ProbeKind(11, []);
            case "RSSI":
                return new Types_ProbeKind(19, []);
            case "CUMUL":
                return new Types_ProbeKind(20, []);
            case "ULTRASOUND":
                return new Types_ProbeKind(12, []);
            case "IMPULSION":
                return new Types_ProbeKind(13, []);
            case "IMPULSION1L":
                return new Types_ProbeKind(14, []);
            case "IMPULSION10L":
                return new Types_ProbeKind(15, []);
            case "CONTACT":
                return new Types_ProbeKind(16, []);
            case "IRRADIATION":
                return new Types_ProbeKind(18, []);
            case "WIND":
                return new Types_ProbeKind(21, []);
            case "SPEED":
                return new Types_ProbeKind(22, []);
            case "RAIN":
                return new Types_ProbeKind(23, []);
            case "PYRANOMETER":
                return new Types_ProbeKind(24, []);
            default:
                throw new Error(toText(printf("unknown probeKind %s"))(_arg));
        }
    };
}

export function Types_ProbeKind_get_decode() {
    return (path_2) => ((value_1) => andThen(uncurry3((name) => {
        const name_1 = name.toUpperCase();
        switch (name_1) {
            case "V010":
                return (arg10$0040) => ((arg20$0040) => succeed(new Types_ProbeKind(6, []), arg10$0040, arg20$0040));
            case "V0420":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Types_ProbeKind(7, []), arg10$0040_1, arg20$0040_1));
            case "HYGRO":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Types_ProbeKind(9, []), arg10$0040_2, arg20$0040_2));
            case "CONDUCTIVITY":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Types_ProbeKind(10, []), arg10$0040_3, arg20$0040_3));
            case "CTN":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Types_ProbeKind(5, []), arg10$0040_4, arg20$0040_4));
            case "CO2":
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Types_ProbeKind(3, []), arg10$0040_5, arg20$0040_5));
            case "REDOX":
                return (arg10$0040_6) => ((arg20$0040_6) => succeed(new Types_ProbeKind(4, []), arg10$0040_6, arg20$0040_6));
            case "EVA":
                return (arg10$0040_7) => ((arg20$0040_7) => succeed(new Types_ProbeKind(1, []), arg10$0040_7, arg20$0040_7));
            case "TC":
                return (arg10$0040_8) => ((arg20$0040_8) => succeed(new Types_ProbeKind(0, []), arg10$0040_8, arg20$0040_8));
            case "ECVA":
                return (arg10$0040_9) => ((arg20$0040_9) => succeed(new Types_ProbeKind(2, []), arg10$0040_9, arg20$0040_9));
            case "PRESSION":
                return (arg10$0040_10) => ((arg20$0040_10) => succeed(new Types_ProbeKind(17, []), arg10$0040_10, arg20$0040_10));
            case "BATTERY":
                return (arg10$0040_11) => ((arg20$0040_11) => succeed(new Types_ProbeKind(11, []), arg10$0040_11, arg20$0040_11));
            case "RSSI":
                return (arg10$0040_12) => ((arg20$0040_12) => succeed(new Types_ProbeKind(19, []), arg10$0040_12, arg20$0040_12));
            case "ULTRASOUND":
                return (arg10$0040_13) => ((arg20$0040_13) => succeed(new Types_ProbeKind(12, []), arg10$0040_13, arg20$0040_13));
            case "IMPULSION":
                return (arg10$0040_14) => ((arg20$0040_14) => succeed(new Types_ProbeKind(13, []), arg10$0040_14, arg20$0040_14));
            case "IMPULSION1L":
                return (arg10$0040_15) => ((arg20$0040_15) => succeed(new Types_ProbeKind(14, []), arg10$0040_15, arg20$0040_15));
            case "IMPULSION10L":
                return (arg10$0040_16) => ((arg20$0040_16) => succeed(new Types_ProbeKind(15, []), arg10$0040_16, arg20$0040_16));
            case "CONTACT":
                return (arg10$0040_17) => ((arg20$0040_17) => succeed(new Types_ProbeKind(16, []), arg10$0040_17, arg20$0040_17));
            case "TCK":
                return (arg10$0040_18) => ((arg20$0040_18) => succeed(new Types_ProbeKind(8, []), arg10$0040_18, arg20$0040_18));
            case "IRRADIATION":
                return (arg10$0040_19) => ((arg20$0040_19) => succeed(new Types_ProbeKind(18, []), arg10$0040_19, arg20$0040_19));
            case "CUMUL":
                return (arg10$0040_20) => ((arg20$0040_20) => succeed(new Types_ProbeKind(13, []), arg10$0040_20, arg20$0040_20));
            case "WIND":
                return (arg10$0040_21) => ((arg20$0040_21) => succeed(new Types_ProbeKind(21, []), arg10$0040_21, arg20$0040_21));
            case "SPEED":
                return (arg10$0040_22) => ((arg20$0040_22) => succeed(new Types_ProbeKind(22, []), arg10$0040_22, arg20$0040_22));
            case "RAIN":
                return (arg10$0040_23) => ((arg20$0040_23) => succeed(new Types_ProbeKind(23, []), arg10$0040_23, arg20$0040_23));
            case "PYRANOMETER":
                return (arg10$0040_24) => ((arg20$0040_24) => succeed(new Types_ProbeKind(24, []), arg10$0040_24, arg20$0040_24));
            default: {
                const msg = toText(printf("Failed to decode `%s` it\'s an invalid case for `ProbeKind`"))(name_1);
                return (path_1) => ((arg20$0040_25) => fail(msg, path_1, arg20$0040_25));
            }
        }
    }), string, path_2, value_1));
}

export function Types_SensorKind_get_decode() {
    return (path_2) => ((value_1) => andThen(uncurry3((_arg) => {
        switch (_arg) {
            case "TEST":
                return (arg10$0040) => ((arg20$0040) => succeed(new Types_SensorKind(0, []), arg10$0040, arg20$0040));
            case "IOT3CTN":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Types_SensorKind(1, []), arg10$0040_1, arg20$0040_1));
            case "IOTCTN2":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Types_SensorKind(2, []), arg10$0040_2, arg20$0040_2));
            case "IOT2CTN":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Types_SensorKind(3, []), arg10$0040_3, arg20$0040_3));
            case "IOT2CTN10":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Types_SensorKind(4, []), arg10$0040_4, arg20$0040_4));
            case "IOT2CTN100":
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Types_SensorKind(5, []), arg10$0040_5, arg20$0040_5));
            case "IOT3000PA":
                return (arg10$0040_6) => ((arg20$0040_6) => succeed(new Types_SensorKind(8, []), arg10$0040_6, arg20$0040_6));
            case "IOTV010":
                return (arg10$0040_7) => ((arg20$0040_7) => succeed(new Types_SensorKind(24, []), arg10$0040_7, arg20$0040_7));
            case "IOTPHY":
                return (arg10$0040_8) => ((arg20$0040_8) => succeed(new Types_SensorKind(25, []), arg10$0040_8, arg20$0040_8));
            case "METEO":
                return (arg10$0040_9) => ((arg20$0040_9) => succeed(new Types_SensorKind(26, []), arg10$0040_9, arg20$0040_9));
            case "IOTV0420":
                return (arg10$0040_10) => ((arg20$0040_10) => succeed(new Types_SensorKind(27, []), arg10$0040_10, arg20$0040_10));
            case "IOTV010420":
                return (arg10$0040_11) => ((arg20$0040_11) => succeed(new Types_SensorKind(28, []), arg10$0040_11, arg20$0040_11));
            case "IOT010P":
                return (arg10$0040_12) => ((arg20$0040_12) => succeed(new Types_SensorKind(29, []), arg10$0040_12, arg20$0040_12));
            case "IOT2T1C":
                return (arg10$0040_13) => ((arg20$0040_13) => succeed(new Types_SensorKind(30, []), arg10$0040_13, arg20$0040_13));
            case "SIGFOXTEST":
                return (arg10$0040_14) => ((arg20$0040_14) => succeed(new Types_SensorKind(31, []), arg10$0040_14, arg20$0040_14));
            case "IOCPV":
                return (arg10$0040_15) => ((arg20$0040_15) => succeed(new Types_SensorKind(7, []), arg10$0040_15, arg20$0040_15));
            case "THI":
                return (arg10$0040_16) => ((arg20$0040_16) => succeed(new Types_SensorKind(20, []), arg10$0040_16, arg20$0040_16));
            case "SYSTEM":
                return (arg10$0040_17) => ((arg20$0040_17) => succeed(new Types_SensorKind(21, []), arg10$0040_17, arg20$0040_17));
            case "TRIVA":
                return (arg10$0040_18) => ((arg20$0040_18) => succeed(new Types_SensorKind(19, []), arg10$0040_18, arg20$0040_18));
            case "TH":
                return (arg10$0040_19) => ((arg20$0040_19) => succeed(new Types_SensorKind(22, []), arg10$0040_19, arg20$0040_19));
            case "T":
                return (arg10$0040_20) => ((arg20$0040_20) => succeed(new Types_SensorKind(23, []), arg10$0040_20, arg20$0040_20));
            case "LORAT":
                return (arg10$0040_21) => ((arg20$0040_21) => succeed(new Types_SensorKind(32, []), arg10$0040_21, arg20$0040_21));
            case "LORATH":
                return (arg10$0040_22) => ((arg20$0040_22) => succeed(new Types_SensorKind(36, []), arg10$0040_22, arg20$0040_22));
            case "LORA2T1P":
                return (arg10$0040_23) => ((arg20$0040_23) => succeed(new Types_SensorKind(33, []), arg10$0040_23, arg20$0040_23));
            case "LORA2T1C":
                return (arg10$0040_24) => ((arg20$0040_24) => succeed(new Types_SensorKind(34, []), arg10$0040_24, arg20$0040_24));
            case "LORACO2":
                return (arg10$0040_25) => ((arg20$0040_25) => succeed(new Types_SensorKind(35, []), arg10$0040_25, arg20$0040_25));
            case "LORA2P":
                return (arg10$0040_26) => ((arg20$0040_26) => succeed(new Types_SensorKind(41, []), arg10$0040_26, arg20$0040_26));
            case "IOT2P":
                return (arg10$0040_27) => ((arg20$0040_27) => succeed(new Types_SensorKind(40, []), arg10$0040_27, arg20$0040_27));
            case "COV":
                return (arg10$0040_28) => ((arg20$0040_28) => succeed(new Types_SensorKind(42, []), arg10$0040_28, arg20$0040_28));
            case "LORA3CTN":
                return (arg10$0040_29) => ((arg20$0040_29) => succeed(new Types_SensorKind(37, []), arg10$0040_29, arg20$0040_29));
            case "LORA2CTN":
                return (arg10$0040_30) => ((arg20$0040_30) => succeed(new Types_SensorKind(38, []), arg10$0040_30, arg20$0040_30));
            case "LORA2TCK":
                return (arg10$0040_31) => ((arg20$0040_31) => succeed(new Types_SensorKind(39, []), arg10$0040_31, arg20$0040_31));
            case "IOTIMPULSE":
                return (arg10$0040_32) => ((arg20$0040_32) => succeed(new Types_SensorKind(9, []), arg10$0040_32, arg20$0040_32));
            case "THERMOK":
                return (arg10$0040_33) => ((arg20$0040_33) => succeed(new Types_SensorKind(6, []), arg10$0040_33, arg20$0040_33));
            case "M19SOLA":
                return (arg10$0040_34) => ((arg20$0040_34) => succeed(new Types_SensorKind(10, []), arg10$0040_34, arg20$0040_34));
            case "M25ULTRASOUND":
                return (arg10$0040_35) => ((arg20$0040_35) => succeed(new Types_SensorKind(11, []), arg10$0040_35, arg20$0040_35));
            case "ULSA":
                return (arg10$0040_36) => ((arg20$0040_36) => succeed(new Types_SensorKind(12, []), arg10$0040_36, arg20$0040_36));
            case "LIQ":
                return (arg10$0040_37) => ((arg20$0040_37) => succeed(new Types_SensorKind(13, []), arg10$0040_37, arg20$0040_37));
            case "M32":
                return (arg10$0040_38) => ((arg20$0040_38) => succeed(new Types_SensorKind(14, []), arg10$0040_38, arg20$0040_38));
            case "CO2":
                return (arg10$0040_39) => ((arg20$0040_39) => succeed(new Types_SensorKind(15, []), arg10$0040_39, arg20$0040_39));
            case "CONTACTS2":
                return (arg10$0040_40) => ((arg20$0040_40) => succeed(new Types_SensorKind(16, []), arg10$0040_40, arg20$0040_40));
            case "REDOX":
                return (arg10$0040_41) => ((arg20$0040_41) => succeed(new Types_SensorKind(17, []), arg10$0040_41, arg20$0040_41));
            case "VA":
                return (arg10$0040_42) => ((arg20$0040_42) => succeed(new Types_SensorKind(18, []), arg10$0040_42, arg20$0040_42));
            case "PT100":
                return (arg10$0040_43) => ((arg20$0040_43) => succeed(new Types_SensorKind(43, []), arg10$0040_43, arg20$0040_43));
            case "GENERIC010420":
                return (arg10$0040_44) => ((arg20$0040_44) => succeed(new Types_SensorKind(44, []), arg10$0040_44, arg20$0040_44));
            default: {
                const msg = toText(printf("Failed to decode `%s` it\'s an invalid case for `SensorKind`"))(_arg);
                return (path_1) => ((arg20$0040_45) => fail(msg, path_1, arg20$0040_45));
            }
        }
    }), string, path_2, value_1));
}

export function Types_SensorKind_get_toLabel() {
    return (_arg) => ((_arg.tag === 1) ? "MG-IOT-CTN-3" : ((_arg.tag === 2) ? "MG-IOT-CTN-2" : ((_arg.tag === 3) ? "MG-IOT-2T1PULS" : ((_arg.tag === 4) ? "MG-IOT-2T1PULS10" : ((_arg.tag === 5) ? "MG-IOT-2T1PULS100" : ((_arg.tag === 8) ? "MG-IOT-3000PA" : ((_arg.tag === 7) ? "iocPV-OCCION" : ((_arg.tag === 24) ? "MG-IOT-010" : ((_arg.tag === 25) ? "MG-IOT-PHY" : ((_arg.tag === 26) ? "MG-IOT-METEO" : ((_arg.tag === 27) ? "MG-IOT-420" : ((_arg.tag === 28) ? "MG-IOT-420-010" : ((_arg.tag === 29) ? "MG-IOT-010-P" : ((_arg.tag === 30) ? "MG-IOT-2T1C" : ((_arg.tag === 31) ? "MG-IOT-TEST" : ((_arg.tag === 20) ? "MG-IOT-THI" : ((_arg.tag === 21) ? "SYSTEM" : ((_arg.tag === 19) ? "MG-IOT-TRI-VA" : ((_arg.tag === 22) ? "MG-IOT-TH" : ((_arg.tag === 23) ? "MG-IOT-T" : ((_arg.tag === 32) ? "MG-LORA-T" : ((_arg.tag === 36) ? "MG-LORA-TH" : ((_arg.tag === 33) ? "MG-LORA-2T1P" : ((_arg.tag === 34) ? "MG-LORA-2T1C" : ((_arg.tag === 35) ? "MG-LORA-CO2" : ((_arg.tag === 41) ? "MG-LORA-2P" : ((_arg.tag === 40) ? "MG-IOT-2P" : ((_arg.tag === 42) ? "MG-IOT-COV" : ((_arg.tag === 37) ? "MG-LORA-3CTN" : ((_arg.tag === 38) ? "MG-LORA-CTN-2" : ((_arg.tag === 39) ? "MG-LORA-2TCK" : ((_arg.tag === 9) ? "MG-IOT-GAZ-EAU" : ((_arg.tag === 10) ? "SOLAIRE" : ((_arg.tag === 6) ? "MG-IOT-TCK" : ((_arg.tag === 11) ? "MG-IOT-ULSB" : ((_arg.tag === 12) ? "MG-IOT-ULSA" : ((_arg.tag === 13) ? "MG-IOT-LIQ" : ((_arg.tag === 14) ? "MG-IOT-T24" : ((_arg.tag === 15) ? "MG-IOT-CO2" : ((_arg.tag === 16) ? "MG-IOT-2CONTACTS" : ((_arg.tag === 17) ? "IOC-REDOX" : ((_arg.tag === 18) ? "MG-IOT-VA" : ((_arg.tag === 43) ? "MG-IOT-PT100" : ((_arg.tag === 44) ? "MG-IOT-NEXTGEN" : "TEST"))))))))))))))))))))))))))))))))))))))))))));
}

export function Types_SensorKind_get_fromLabel() {
    return (_arg) => ((_arg === "SIGFOXTEST") ? (new Types_SensorKind(31, [])) : ((_arg === "IOT2T1C") ? (new Types_SensorKind(30, [])) : ((_arg === "IOTV010") ? (new Types_SensorKind(24, [])) : ((_arg === "IOTPHY") ? (new Types_SensorKind(25, [])) : ((_arg === "METEO") ? (new Types_SensorKind(26, [])) : ((_arg === "IOTV0420") ? (new Types_SensorKind(27, [])) : ((_arg === "IOTV010420") ? (new Types_SensorKind(28, [])) : ((_arg === "IOT010P") ? (new Types_SensorKind(29, [])) : ((_arg === "IOT3CTN") ? (new Types_SensorKind(1, [])) : ((_arg === "IOTCTN2") ? (new Types_SensorKind(2, [])) : ((_arg === "IOT2CTN") ? (new Types_SensorKind(3, [])) : ((_arg === "IOT2CTN10") ? (new Types_SensorKind(4, [])) : ((_arg === "IOT2CTN100") ? (new Types_SensorKind(5, [])) : ((_arg === "IOT3000PA") ? (new Types_SensorKind(8, [])) : ((_arg === "IOCPV") ? (new Types_SensorKind(7, [])) : ((_arg === "THI") ? (new Types_SensorKind(20, [])) : ((_arg === "SYSTEM") ? (new Types_SensorKind(21, [])) : ((_arg === "TRIVA") ? (new Types_SensorKind(19, [])) : ((_arg === "TH") ? (new Types_SensorKind(22, [])) : ((_arg === "T") ? (new Types_SensorKind(23, [])) : ((_arg === "LORAT") ? (new Types_SensorKind(32, [])) : ((_arg === "LORATH") ? (new Types_SensorKind(36, [])) : ((_arg === "LORA2T1P") ? (new Types_SensorKind(33, [])) : ((_arg === "LORA2T1C") ? (new Types_SensorKind(34, [])) : ((_arg === "LORACO2") ? (new Types_SensorKind(35, [])) : ((_arg === "LORA2P") ? (new Types_SensorKind(41, [])) : ((_arg === "COV") ? (new Types_SensorKind(42, [])) : ((_arg === "LORA3CTN") ? (new Types_SensorKind(37, [])) : ((_arg === "LORA2CTN") ? (new Types_SensorKind(38, [])) : ((_arg === "LORA2TCK") ? (new Types_SensorKind(39, [])) : ((_arg === "IOTIMPULSE") ? (new Types_SensorKind(9, [])) : ((_arg === "THERMOK") ? (new Types_SensorKind(6, [])) : ((_arg === "M19SOLA") ? (new Types_SensorKind(10, [])) : ((_arg === "M25ULTRASOUND") ? (new Types_SensorKind(11, [])) : ((_arg === "ULSA") ? (new Types_SensorKind(12, [])) : ((_arg === "LIQ") ? (new Types_SensorKind(13, [])) : ((_arg === "M32") ? (new Types_SensorKind(14, [])) : ((_arg === "CO2") ? (new Types_SensorKind(15, [])) : ((_arg === "CONTACTS2") ? (new Types_SensorKind(16, [])) : ((_arg === "REDOX") ? (new Types_SensorKind(17, [])) : ((_arg === "VA") ? (new Types_SensorKind(18, [])) : ((_arg === "PT100") ? (new Types_SensorKind(43, [])) : ((_arg === "GENERIC010420") ? (new Types_SensorKind(44, [])) : (new Types_SensorKind(0, [])))))))))))))))))))))))))))))))))))))))))))));
}

export function Types_SensorKind_get_fromCode() {
    return (_arg) => {
        switch (_arg) {
            case 6:
                return new Types_SensorKind(0, []);
            case 7:
                return new Types_SensorKind(1, []);
            case 13:
                return new Types_SensorKind(10, []);
            case 19:
                return new Types_SensorKind(11, []);
            case 20:
                return new Types_SensorKind(14, []);
            case 21:
                return new Types_SensorKind(3, []);
            case 34:
                return new Types_SensorKind(9, []);
            default:
                throw new Error("unknown code");
        }
    };
}

export function Types_SensorKind_get_fromHexa() {
    return (_arg) => {
        switch (_arg) {
            case "1A":
                return new Types_SensorKind(1, []);
            case "0D":
                return new Types_SensorKind(8, []);
            case "0F":
                return new Types_SensorKind(24, []);
            case "41":
                return new Types_SensorKind(25, []);
            case "3E":
                return new Types_SensorKind(26, []);
            case "4B":
                return new Types_SensorKind(27, []);
            case "4C":
                return new Types_SensorKind(28, []);
            case "22":
                return new Types_SensorKind(29, []);
            case "2C":
                return new Types_SensorKind(30, []);
            case "25":
                return new Types_SensorKind(7, []);
            case "4E":
                return new Types_SensorKind(20, []);
            case "4D":
                return new Types_SensorKind(19, []);
            case "1B":
                return new Types_SensorKind(22, []);
            case "35":
                return new Types_SensorKind(23, []);
            case "2D":
                return new Types_SensorKind(6, []);
            case "13":
                return new Types_SensorKind(10, []);
            case "19":
                return new Types_SensorKind(12, []);
            case "36":
                return new Types_SensorKind(13, []);
            case "20":
                return new Types_SensorKind(14, []);
            case "0A":
                return new Types_SensorKind(15, []);
            case "32":
                return new Types_SensorKind(16, []);
            case "24":
                return new Types_SensorKind(17, []);
            case "26":
                return new Types_SensorKind(18, []);
            case "94":
                return new Types_SensorKind(43, []);
            case "1E":
                return new Types_SensorKind(44, []);
            default:
                throw new Error("unknown code");
        }
    };
}

export function Types_SensorKind_get_probeCount() {
    return (_arg) => ((_arg.tag === 1) ? 5 : ((_arg.tag === 2) ? 4 : ((_arg.tag === 24) ? 5 : ((_arg.tag === 25) ? 5 : ((_arg.tag === 26) ? 7 : ((_arg.tag === 27) ? 5 : ((_arg.tag === 28) ? 5 : ((_arg.tag === 29) ? 5 : ((_arg.tag === 31) ? 3 : ((_arg.tag === 30) ? 5 : ((_arg.tag === 3) ? 5 : ((_arg.tag === 4) ? 5 : ((_arg.tag === 5) ? 5 : ((_arg.tag === 6) ? 4 : ((_arg.tag === 8) ? 4 : ((_arg.tag === 7) ? 5 : ((_arg.tag === 20) ? 4 : ((_arg.tag === 21) ? 10 : ((_arg.tag === 19) ? 5 : ((_arg.tag === 22) ? 4 : ((_arg.tag === 23) ? 4 : ((_arg.tag === 32) ? 4 : ((_arg.tag === 36) ? 4 : ((_arg.tag === 33) ? 5 : ((_arg.tag === 34) ? 5 : ((_arg.tag === 35) ? 5 : ((_arg.tag === 41) ? 6 : ((_arg.tag === 40) ? 6 : ((_arg.tag === 42) ? 4 : ((_arg.tag === 37) ? 5 : ((_arg.tag === 38) ? 5 : ((_arg.tag === 39) ? 4 : ((_arg.tag === 9) ? 5 : ((_arg.tag === 10) ? 5 : ((_arg.tag === 11) ? 6 : ((_arg.tag === 12) ? 6 : ((_arg.tag === 13) ? 4 : ((_arg.tag === 14) ? 3 : ((_arg.tag === 15) ? 5 : ((_arg.tag === 16) ? 5 : ((_arg.tag === 17) ? 4 : ((_arg.tag === 18) ? 5 : ((_arg.tag === 43) ? 5 : ((_arg.tag === 44) ? 5 : 4))))))))))))))))))))))))))))))))))))))))))));
}

export function Types_SensorKind_get_dailyFunctionCall() {
    return (_arg) => ((_arg.tag === 30) ? (4 * 24) : ((_arg.tag === 31) ? (1 * 24) : ((_arg.tag === 24) ? (4 * 24) : ((_arg.tag === 25) ? (4 * 24) : ((_arg.tag === 26) ? (4 * 24) : ((_arg.tag === 27) ? (4 * 24) : ((_arg.tag === 28) ? (4 * 24) : ((_arg.tag === 29) ? (1 * 24) : ((_arg.tag === 1) ? (4 * 24) : ((_arg.tag === 2) ? (4 * 24) : ((_arg.tag === 3) ? (4 * 24) : ((_arg.tag === 4) ? (4 * 24) : ((_arg.tag === 5) ? (4 * 24) : ((_arg.tag === 6) ? (4 * 24) : ((_arg.tag === 8) ? (4 * 24) : ((_arg.tag === 7) ? (4 * 24) : ((_arg.tag === 20) ? (4 * 24) : ((_arg.tag === 21) ? (4 * 24) : ((_arg.tag === 19) ? (1 * 24) : ((_arg.tag === 22) ? (4 * 24) : ((_arg.tag === 23) ? (4 * 24) : ((_arg.tag === 32) ? (4 * 24) : ((_arg.tag === 36) ? (4 * 24) : ((_arg.tag === 33) ? (4 * 24) : ((_arg.tag === 34) ? (4 * 24) : ((_arg.tag === 35) ? (4 * 24) : ((_arg.tag === 41) ? (4 * 24) : ((_arg.tag === 40) ? (4 * 24) : ((_arg.tag === 42) ? (2 * 24) : ((_arg.tag === 37) ? (4 * 24) : ((_arg.tag === 38) ? (4 * 24) : ((_arg.tag === 39) ? (4 * 24) : ((_arg.tag === 9) ? (4 * 24) : ((_arg.tag === 10) ? (4 * 24) : ((_arg.tag === 11) ? (4 * 24) : ((_arg.tag === 12) ? (4 * 24) : ((_arg.tag === 13) ? (1 * 24) : ((_arg.tag === 14) ? (1 * 4) : ((_arg.tag === 15) ? (2 * 24) : ((_arg.tag === 16) ? (4 * 24) : ((_arg.tag === 17) ? (4 * 24) : ((_arg.tag === 18) ? (1 * 24) : ((_arg.tag === 43) ? (4 * 24) : ((_arg.tag === 44) ? (4 * 24) : (4 * 24)))))))))))))))))))))))))))))))))))))))))))));
}

export function Types_Token_Encode_1CDEA135(o) {
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "write", o.Write, Encoder_string(new Encoder_FieldCheck(0, []), "read", o.Read, Encoder_empty)));
}

export function Types_Token_get_Decoder() {
    return (path_2) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Types_Token((objectArg = get$.Required, objectArg.Field("read", string)), (objectArg_1 = get$.Required, objectArg_1.Field("write", string)));
    }, path_2, v));
}

export function Types_Contract_Encode_Z579A664(o) {
    let input_6;
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(1, []), "server", o.Server, (input_6 = Encoder_int(new Encoder_FieldCheck(0, []), "maxActiveSeries", o.MaxActiveSeries, Encoder_string(new Encoder_FieldCheck(0, []), "name", o.Name, Encoder_string(new Encoder_FieldCheck(0, []), "docKind", toString_2(o.DocKind).toUpperCase(), Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty)))))), Encoder_custom("token", some(Types_Token_Encode_1CDEA135(o.Token)), input_6))));
}

export function Types_Contract_get_Decoder() {
    return (path_8) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2, objectArg_3, objectArg_4, arg_11, objectArg_5, objectArg_6;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("_id", string);
        const Rev = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_100(string, path_2, value_2))), undefined);
        return new Types_Contract(Id, defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_deleted", (path_4, value_5) => option_100(bool, path_4, value_5))), undefined), Rev, new Types_DocKind(5, []), (objectArg_3 = get$.Required, objectArg_3.Field("name", string)), (objectArg_4 = get$.Required, objectArg_4.Field("maxActiveSeries", uncurry2(int))), (arg_11 = Types_Token_get_Decoder(), (objectArg_5 = get$.Required, objectArg_5.Field("token", uncurry2(arg_11)))), defaultArg((objectArg_6 = get$.Optional, objectArg_6.Field("server", (path_7, value_9) => option_100(string, path_7, value_9))), "warp10.gra1.metrics.ovh.net"));
    }, path_8, v));
}

export function Types_Calibration_get_Decoder() {
    return (path_5) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Types_Calibration((objectArg = get$.Required, objectArg.Field("date", datetime)), (objectArg_1 = get$.Required, objectArg_1.Field("value", float)), (objectArg_2 = get$.Required, objectArg_2.Field("operation", (path_2, value_1) => andThen(uncurry3((_arg) => {
            switch (_arg) {
                case "PLUS":
                    return (arg10$0040) => ((arg20$0040) => succeed(new Types_CalibrationOperation(0, []), arg10$0040, arg20$0040));
                case "MINUS":
                    return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Types_CalibrationOperation(1, []), arg10$0040_1, arg20$0040_1));
                default: {
                    const msg = toText(printf("Unknown operation type %s"))(_arg);
                    return (path_1) => ((arg20$0040_2) => fail(msg, path_1, arg20$0040_2));
                }
            }
        }), string, path_2, value_1))));
    }, path_5, v));
}

export function Types_Calibration_Encoder_3B585444(o) {
    let input_2;
    return Encoder_toPlainJsObj((input_2 = Encoder_string(new Encoder_FieldCheck(0, []), "date", toString_1(o.Date, "O", {}), Encoder_float(new Encoder_FieldCheck(0, []), "value", o.Value, Encoder_empty)), Encoder_string(new Encoder_FieldCheck(0, []), "operation", toString_2(o.Operation).toUpperCase(), input_2)));
}

export function Types_Calibration_Encode_3B585444(o) {
    return object([["date", datetime_1(o.Date)], ["value", o.Value], ["operation", toString_2(o.Operation).toUpperCase()]]);
}

export function Types_Interpolation_getValue(value, s, o, p) {
    let matchResult;
    if (p != null) {
        if (p.tag === 7) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return ((value - 4) * ((o.Max - o.Zero) / o.Range)) + o.Zero;
        default:
            return (value * ((o.Max - o.Zero) / o.Range)) + o.Zero;
    }
}

export function Types_Interpolation_get_Decoder() {
    return (path_4) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2, objectArg_3;
        return new Types_Interpolation((objectArg = get$.Required, objectArg.Field("zero", float)), (objectArg_1 = get$.Required, objectArg_1.Field("max", float)), (objectArg_2 = get$.Required, objectArg_2.Field("range", float)), (objectArg_3 = get$.Required, objectArg_3.Field("unit", string)));
    }, path_4, v));
}

export function Types_Interpolation_Encoder_165A9DE4(o) {
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "unit", o.Unit, Encoder_float(new Encoder_FieldCheck(0, []), "range", o.Range, Encoder_float(new Encoder_FieldCheck(0, []), "max", o.Max, Encoder_float(new Encoder_FieldCheck(0, []), "zero", o.Zero, Encoder_empty)))));
}

export function Types_Interpolation_Encode_165A9DE4(o) {
    return object([["zero", o.Zero], ["max", o.Max], ["range", o.Range], ["unit", o.Unit]]);
}

export function Types_Coeff_getValue(value, o) {
    return value * o.Coeff;
}

export function Types_Coeff_get_Decoder() {
    return (path_2) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Types_Coeff((objectArg = get$.Required, objectArg.Field("coeff", float)), (objectArg_1 = get$.Required, objectArg_1.Field("unit", string)));
    }, path_2, v));
}

export function Types_Coeff_Encoder_1C10E647(o) {
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(0, []), "unit", o.Unit, Encoder_float(new Encoder_FieldCheck(0, []), "coeff", o.Coeff, Encoder_empty)));
}

export function Types_Coeff_Encode_1C10E647(o) {
    return object([["coeff", o.Coeff], ["unit", o.Unit]]);
}

export function Types_SensorOption_fromString_Z721C83C5(opt) {
    const matchValue = opt.toUpperCase();
    switch (matchValue) {
        case "ALARMSCHEDULER":
            return new Types_SensorOption(0, []);
        case "APISHARE":
            return new Types_SensorOption(1, []);
        case "SMS":
            return new Types_SensorOption(2, []);
        case "VOICE":
            return new Types_SensorOption(3, []);
        case "ALARMOFF":
            return new Types_SensorOption(4, []);
        case "LDC":
            return new Types_SensorOption(5, []);
        case "BACKTOWORK":
            return new Types_SensorOption(6, []);
        case "APLUS":
            return new Types_SensorOption(7, []);
        case "APLUSSMS":
            return new Types_SensorOption(8, []);
        case "APLUSVOICE":
            return new Types_SensorOption(9, []);
        case "APLUSMAX":
            return new Types_SensorOption(10, []);
        default:
            throw new Error(toText(printf("unable to decode sensor option %s"))(opt));
    }
}

export function Types_SensorOption_get_Decoder() {
    return (path_2) => ((value_1) => andThen(uncurry3((_arg) => {
        switch (_arg) {
            case "ALARMSCHEDULER":
                return (arg10$0040) => ((arg20$0040) => succeed(new Types_SensorOption(0, []), arg10$0040, arg20$0040));
            case "APISHARE":
                return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Types_SensorOption(1, []), arg10$0040_1, arg20$0040_1));
            case "SMS":
                return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Types_SensorOption(2, []), arg10$0040_2, arg20$0040_2));
            case "VOICE":
                return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Types_SensorOption(3, []), arg10$0040_3, arg20$0040_3));
            case "ALARMOFF":
                return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Types_SensorOption(4, []), arg10$0040_4, arg20$0040_4));
            case "BACKTOWORK":
                return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Types_SensorOption(6, []), arg10$0040_5, arg20$0040_5));
            case "LDC":
                return (arg10$0040_6) => ((arg20$0040_6) => succeed(new Types_SensorOption(5, []), arg10$0040_6, arg20$0040_6));
            case "APLUS":
                return (arg10$0040_7) => ((arg20$0040_7) => succeed(new Types_SensorOption(7, []), arg10$0040_7, arg20$0040_7));
            case "APLUSSMS":
                return (arg10$0040_8) => ((arg20$0040_8) => succeed(new Types_SensorOption(8, []), arg10$0040_8, arg20$0040_8));
            case "APLUSVOICE":
                return (arg10$0040_9) => ((arg20$0040_9) => succeed(new Types_SensorOption(9, []), arg10$0040_9, arg20$0040_9));
            case "APLUSMAX":
                return (arg10$0040_10) => ((arg20$0040_10) => succeed(new Types_SensorOption(10, []), arg10$0040_10, arg20$0040_10));
            default: {
                const msg = toText(printf("Failed to decode `%s` it\'s an invalid case for `SensorOption`"))(_arg);
                return (path_1) => ((arg20$0040_11) => fail(msg, path_1, arg20$0040_11));
            }
        }
    }), string, path_2, value_1));
}

export function Types_ScheduleDay_get_Decoder() {
    return (path_2) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Types_ScheduleDay((objectArg = get$.Required, objectArg.Field("Hour", uncurry2(int))), (objectArg_1 = get$.Required, objectArg_1.Field("Day", (path_1, value) => andThen(uncurry3((_arg) => {
            switch (_arg) {
                case 0:
                    return (arg10$0040) => ((arg20$0040) => succeed(1, arg10$0040, arg20$0040));
                case 1:
                    return (arg10$0040_1) => ((arg20$0040_1) => succeed(2, arg10$0040_1, arg20$0040_1));
                case 2:
                    return (arg10$0040_2) => ((arg20$0040_2) => succeed(3, arg10$0040_2, arg20$0040_2));
                case 3:
                    return (arg10$0040_3) => ((arg20$0040_3) => succeed(4, arg10$0040_3, arg20$0040_3));
                case 4:
                    return (arg10$0040_4) => ((arg20$0040_4) => succeed(5, arg10$0040_4, arg20$0040_4));
                case 5:
                    return (arg10$0040_5) => ((arg20$0040_5) => succeed(6, arg10$0040_5, arg20$0040_5));
                case 6:
                    return (arg10$0040_6) => ((arg20$0040_6) => succeed(0, arg10$0040_6, arg20$0040_6));
                default: {
                    const msg = toText(printf("Failed to decode `%i` it\'s an invalid case for `Day`"))(_arg);
                    return (path) => ((arg20$0040_7) => fail(msg, path, arg20$0040_7));
                }
            }
        }), uncurry2(int), path_1, value))));
    }, path_2, v));
}

export function Types_ScheduleDay_Encode_Z57C96D89(o) {
    let matchValue;
    return Encoder_toPlainJsObj(Encoder_int(new Encoder_FieldCheck(0, []), "Day", (matchValue = (o.Day | 0), (matchValue === 1) ? ((toConsole(printf("Monday")), 0)) : ((matchValue === 2) ? ((toConsole(printf("Tuesday")), 1)) : ((matchValue === 3) ? ((toConsole(printf("Wed")), 2)) : ((matchValue === 4) ? ((toConsole(printf("Thursday")), 3)) : ((matchValue === 5) ? ((toConsole(printf("Friday")), 4)) : ((matchValue === 6) ? ((toConsole(printf("Saturday")), 5)) : 6)))))), Encoder_int(new Encoder_FieldCheck(0, []), "Hour", o.Hour, Encoder_empty)));
}

export function Types_ScheduleDay_EncodeForPouch_Z57C96D89(o) {
    let matchValue;
    return object([["Hour", o.Hour], ["Day", (matchValue = (o.Day | 0), (matchValue === 1) ? 0 : ((matchValue === 2) ? 1 : ((matchValue === 3) ? 2 : ((matchValue === 4) ? 3 : ((matchValue === 5) ? 4 : ((matchValue === 6) ? 5 : 6))))))]]);
}

export function Types_AlarmSettings_Encode_A1DDADB(o) {
    if (o == null) {
        return {};
    }
    else {
        const o_1 = o;
        return Encoder_toPlainJsObj(Encoder_float(new Encoder_FieldCheck(1, []), "max", o_1.Max, Encoder_float(new Encoder_FieldCheck(1, []), "min", o_1.Min, Encoder_empty)));
    }
}

export function Types_AlarmSettings_EncodeForCouch_A1DDADB(o) {
    if (o == null) {
        return nil;
    }
    else {
        const o_1 = o;
        const matchValue = o_1.Max;
        const matchValue_1 = o_1.Min;
        if (matchValue == null) {
            if (matchValue_1 != null) {
                const min_1 = matchValue_1;
                return object([["min", min_1]]);
            }
            else {
                return nil;
            }
        }
        else if (matchValue_1 == null) {
            const max_1 = matchValue;
            return object([["max", max_1]]);
        }
        else {
            const max = matchValue;
            const min = matchValue_1;
            return object([["min", min], ["max", max]]);
        }
    }
}

export function Types_AlarmSettings_get_Decoder() {
    return (path_4) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1;
        return new Types_AlarmSettings(defaultArg((objectArg = get$.Optional, objectArg.Field("min", (path_1, value_1) => option_100(float, path_1, value_1))), undefined), defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("max", (path_3, value_4) => option_100(float, path_3, value_4))), undefined));
    }, path_4, v));
}

export function Types_CumulParameters_Encode_Z2D7889CA(o) {
    return Encoder_toPlainJsObj(Encoder_date(new Encoder_FieldCheck(1, []), "lastUpdate", o.LastUpdate, Encoder_int(new Encoder_FieldCheck(0, []), "cumulIndex", o.CumulIndex, Encoder_bool(new Encoder_FieldCheck(0, []), "resetCumul", o.ResetCumul, Encoder_empty))));
}

export function Types_CumulParameters_get_Decoder() {
    return (path_3) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Types_CumulParameters((objectArg = get$.Required, objectArg.Field("resetCumul", bool)), (objectArg_1 = get$.Required, objectArg_1.Field("cumulIndex", uncurry2(int))), defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("lastUpdate", (path_2, value_2) => option_100(datetime, path_2, value_2))), undefined));
    }, path_3, v));
}

export function Types_Alarm_get_BASEDELAY() {
    return 360;
}

export function Types_Alarm_get_Empty() {
    return new Types_Alarm(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, 5, 0, undefined, undefined, undefined, 360, 0, false);
}

export function Types_Alarm_Encode_1C7BB4FD(o) {
    let input_20, input_9, input_8, input_7, input_6, input_5, input_4, input_3, input_2, input_1;
    return Encoder_toPlainJsObj(Encoder_bool(new Encoder_FieldCheck(1, []), "ignore", o.Ignore, (input_20 = Encoder_list(new Encoder_FieldCheck(1, []), "telsForVoice", o.TelsForVoice, undefined, Encoder_list(new Encoder_FieldCheck(1, []), "tels", o.Tels, undefined, Encoder_list(new Encoder_FieldCheck(1, []), "emails", o.Emails, undefined, Encoder_bool(new Encoder_FieldCheck(0, []), "active", o.Activate, Encoder_list(new Encoder_FieldCheck(1, []), "smsSent", o.SmsSent, undefined, Encoder_int(new Encoder_FieldCheck(1, []), "emailCount", o.EmailCount, Encoder_int(new Encoder_FieldCheck(1, []), "voiceCount", o.VoiceCount, Encoder_int(new Encoder_FieldCheck(1, []), "ignoreInterval", o.IgnoreInterval, Encoder_int(new Encoder_FieldCheck(0, []), "delayInterval", o.DelayInterval, Encoder_int(new Encoder_FieldCheck(0, []), "smsCount", o.SmsCount, (input_9 = ((input_8 = ((input_7 = ((input_6 = ((input_5 = ((input_4 = ((input_3 = ((input_2 = ((input_1 = Encoder_custom("s1", some(Types_AlarmSettings_Encode_A1DDADB(o.S1)), Encoder_empty), Encoder_custom("s2", some(Types_AlarmSettings_Encode_A1DDADB(o.S2)), input_1))), Encoder_custom("s3", some(Types_AlarmSettings_Encode_A1DDADB(o.S3)), input_2))), Encoder_custom("s4", some(Types_AlarmSettings_Encode_A1DDADB(o.S4)), input_3))), Encoder_custom("s5", some(Types_AlarmSettings_Encode_A1DDADB(o.S5)), input_4))), Encoder_custom("s6", some(Types_AlarmSettings_Encode_A1DDADB(o.S6)), input_5))), Encoder_custom("s7", some(Types_AlarmSettings_Encode_A1DDADB(o.S7)), input_6))), Encoder_custom("s8", some(Types_AlarmSettings_Encode_A1DDADB(o.S8)), input_7))), Encoder_custom("s9", some(Types_AlarmSettings_Encode_A1DDADB(o.S9)), input_8))), Encoder_custom("s10", some(Types_AlarmSettings_Encode_A1DDADB(o.S10)), input_9)))))))))))), Encoder_custom("battery", some(Types_AlarmSettings_Encode_A1DDADB(o.Battery)), input_20))));
}

export function Types_Alarm_EncodeForCouch_1C7BB4FD(o) {
    let smsSent;
    const matchValue = o.SmsSent;
    smsSent = ((matchValue == null) ? nil : list_6(map((value) => value, matchValue)));
    let emails;
    const matchValue_1 = o.Emails;
    emails = ((matchValue_1 == null) ? nil : list_6(map((value_2) => value_2, matchValue_1)));
    let tels;
    const matchValue_2 = o.Tels;
    tels = ((matchValue_2 == null) ? nil : list_6(map((value_4) => value_4, matchValue_2)));
    let telsfv;
    const matchValue_3 = o.TelsForVoice;
    telsfv = ((matchValue_3 == null) ? nil : list_6(map((value_6) => value_6, matchValue_3)));
    return object([["s1", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.S1)], ["s2", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.S2)], ["s3", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.S3)], ["s4", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.S4)], ["s5", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.S5)], ["s6", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.S6)], ["s7", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.S7)], ["s8", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.S8)], ["s9", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.S9)], ["s10", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.S10)], ["battery", Types_AlarmSettings_EncodeForCouch_A1DDADB(o.Battery)], ["smsCount", o.SmsCount], ["delayInterval", o.DelayInterval], ["ignoreInterval", option_101((value_10) => value_10)(o.IgnoreInterval)], ["voiceCount", option_101((value_12) => value_12)(o.VoiceCount)], ["emailCount", option_101((value_14) => value_14)(o.EmailCount)], ["active", o.Activate], ["smsSent", smsSent], ["emails", emails], ["tels", tels], ["telsForVoice", telsfv], ["ignore", option_101((value_17) => value_17)(o.Ignore)]]);
}

export function Types_Alarm_get_Decoder() {
    return (path_30) => ((v) => object_1((get$) => {
        let objectArg_3, objectArg_4, objectArg_5, arg_13, decoder_3, objectArg_6, arg_15, decoder_4, objectArg_7, arg_17, decoder_5, objectArg_8, arg_19, decoder_6, objectArg_9, arg_21, decoder_7, objectArg_10, arg_23, decoder_8, objectArg_11, arg_25, decoder_9, objectArg_12, arg_27, decoder_10, objectArg_13, arg_29, decoder_11, objectArg_14, arg_31, decoder_12, objectArg_15, arg_33, decoder_13, objectArg_16, objectArg_17, objectArg_18, objectArg_19, objectArg_20, objectArg_21, objectArg_22;
        let Activate;
        const objectArg = get$.Required;
        Activate = objectArg.Field("active", bool);
        let SmsCount;
        const objectArg_1 = get$.Required;
        SmsCount = objectArg_1.Field("smsCount", uncurry2(int));
        let DelayInterval;
        const objectArg_2 = get$.Required;
        DelayInterval = objectArg_2.Field("delayInterval", uncurry2(int));
        const IgnoreInterval = defaultArg((objectArg_3 = get$.Optional, objectArg_3.Field("ignoreInterval", (path_1, value_1) => option_100(uncurry2(int), path_1, value_1))), undefined);
        const VoiceCount = defaultArg((objectArg_4 = get$.Optional, objectArg_4.Field("voiceCount", (path_2, value_3) => option_100(uncurry2(int), path_2, value_3))), undefined);
        const EmailCount = defaultArg((objectArg_5 = get$.Optional, objectArg_5.Field("emailCount", (path_3, value_5) => option_100(uncurry2(int), path_3, value_5))), undefined);
        const S = defaultArg((arg_13 = ((decoder_3 = Types_AlarmSettings_get_Decoder(), (path_4) => ((value_7) => option_100(uncurry2(decoder_3), path_4, value_7)))), (objectArg_6 = get$.Optional, objectArg_6.Field("s1", uncurry2(arg_13)))), undefined);
        const S_1 = defaultArg((arg_15 = ((decoder_4 = Types_AlarmSettings_get_Decoder(), (path_5) => ((value_9) => option_100(uncurry2(decoder_4), path_5, value_9)))), (objectArg_7 = get$.Optional, objectArg_7.Field("s2", uncurry2(arg_15)))), undefined);
        const S_2 = defaultArg((arg_17 = ((decoder_5 = Types_AlarmSettings_get_Decoder(), (path_6) => ((value_11) => option_100(uncurry2(decoder_5), path_6, value_11)))), (objectArg_8 = get$.Optional, objectArg_8.Field("s3", uncurry2(arg_17)))), undefined);
        const S_3 = defaultArg((arg_19 = ((decoder_6 = Types_AlarmSettings_get_Decoder(), (path_7) => ((value_13) => option_100(uncurry2(decoder_6), path_7, value_13)))), (objectArg_9 = get$.Optional, objectArg_9.Field("s4", uncurry2(arg_19)))), undefined);
        const S_4 = defaultArg((arg_21 = ((decoder_7 = Types_AlarmSettings_get_Decoder(), (path_8) => ((value_15) => option_100(uncurry2(decoder_7), path_8, value_15)))), (objectArg_10 = get$.Optional, objectArg_10.Field("s5", uncurry2(arg_21)))), undefined);
        const S_5 = defaultArg((arg_23 = ((decoder_8 = Types_AlarmSettings_get_Decoder(), (path_9) => ((value_17) => option_100(uncurry2(decoder_8), path_9, value_17)))), (objectArg_11 = get$.Optional, objectArg_11.Field("s6", uncurry2(arg_23)))), undefined);
        const S_6 = defaultArg((arg_25 = ((decoder_9 = Types_AlarmSettings_get_Decoder(), (path_10) => ((value_19) => option_100(uncurry2(decoder_9), path_10, value_19)))), (objectArg_12 = get$.Optional, objectArg_12.Field("s7", uncurry2(arg_25)))), undefined);
        const S_7 = defaultArg((arg_27 = ((decoder_10 = Types_AlarmSettings_get_Decoder(), (path_11) => ((value_21) => option_100(uncurry2(decoder_10), path_11, value_21)))), (objectArg_13 = get$.Optional, objectArg_13.Field("s8", uncurry2(arg_27)))), undefined);
        const S_8 = defaultArg((arg_29 = ((decoder_11 = Types_AlarmSettings_get_Decoder(), (path_12) => ((value_23) => option_100(uncurry2(decoder_11), path_12, value_23)))), (objectArg_14 = get$.Optional, objectArg_14.Field("s9", uncurry2(arg_29)))), undefined);
        const S_9 = defaultArg((arg_31 = ((decoder_12 = Types_AlarmSettings_get_Decoder(), (path_13) => ((value_25) => option_100(uncurry2(decoder_12), path_13, value_25)))), (objectArg_15 = get$.Optional, objectArg_15.Field("s10", uncurry2(arg_31)))), undefined);
        const Battery = defaultArg((arg_33 = ((decoder_13 = Types_AlarmSettings_get_Decoder(), (path_14) => ((value_27) => option_100(uncurry2(decoder_13), path_14, value_27)))), (objectArg_16 = get$.Optional, objectArg_16.Field("battery", uncurry2(arg_33)))), undefined);
        const MaxSMSPerDay = defaultArg((objectArg_17 = get$.Optional, objectArg_17.Field("maxSMSPerDay", (path_15, value_29) => option_100(uncurry2(int), path_15, value_29))), 3);
        const SmsSent = defaultArg((objectArg_18 = get$.Optional, objectArg_18.Field("smsSent", (path_18, value_33) => option_100((path_17, value_32) => list_7(string, path_17, value_32), path_18, value_33))), undefined);
        const Tels = defaultArg((objectArg_19 = get$.Optional, objectArg_19.Field("tels", (path_21, value_37) => option_100((path_20, value_36) => list_7(string, path_20, value_36), path_21, value_37))), undefined);
        const TelsForVoice = defaultArg((objectArg_20 = get$.Optional, objectArg_20.Field("telsForVoice", (path_24, value_41) => option_100((path_23, value_40) => list_7(string, path_23, value_40), path_24, value_41))), undefined);
        return new Types_Alarm(S, S_1, S_2, S_3, S_4, S_5, S_6, S_7, S_8, S_9, Activate, defaultArg((objectArg_21 = get$.Optional, objectArg_21.Field("emails", (path_27, value_45) => option_100((path_26, value_44) => list_7(string, path_26, value_44), path_27, value_45))), undefined), Tels, TelsForVoice, Battery, MaxSMSPerDay, SmsCount, VoiceCount, EmailCount, SmsSent, DelayInterval, IgnoreInterval, defaultArg((objectArg_22 = get$.Optional, objectArg_22.Field("ignore", (path_29, value_48) => option_100(bool, path_29, value_48))), undefined));
    }, path_30, v));
}

export const Types_Helpers_decodeDocKind = (path_2) => ((value_1) => andThen(uncurry3((_arg) => {
    switch (_arg) {
        case "USER":
            return (arg10$0040) => ((arg20$0040) => succeed(new Types_DocKind(0, []), arg10$0040, arg20$0040));
        case "MODULE":
            return (arg10$0040_1) => ((arg20$0040_1) => succeed(new Types_DocKind(1, []), arg10$0040_1, arg20$0040_1));
        case "ACCOUNT":
            return (arg10$0040_2) => ((arg20$0040_2) => succeed(new Types_DocKind(2, []), arg10$0040_2, arg20$0040_2));
        case "TAG":
            return (arg10$0040_3) => ((arg20$0040_3) => succeed(new Types_DocKind(3, []), arg10$0040_3, arg20$0040_3));
        case "SENSOR":
            return (arg10$0040_4) => ((arg20$0040_4) => succeed(new Types_DocKind(4, []), arg10$0040_4, arg20$0040_4));
        case "CONTRACT":
            return (arg10$0040_5) => ((arg20$0040_5) => succeed(new Types_DocKind(5, []), arg10$0040_5, arg20$0040_5));
        case "ALARM":
            return (arg10$0040_6) => ((arg20$0040_6) => succeed(new Types_DocKind(6, []), arg10$0040_6, arg20$0040_6));
        case "ALARMSPACE":
            return (arg10$0040_7) => ((arg20$0040_7) => succeed(new Types_DocKind(7, []), arg10$0040_7, arg20$0040_7));
        default: {
            const msg = toText(printf("Failed to decode `%s` it\'s an invalid case for `DocKind`"))(_arg);
            return (path_1) => ((arg20$0040_8) => fail(msg, path_1, arg20$0040_8));
        }
    }
}), string, path_2, value_1));

export function Types_Full_Emtpy(name, kind) {
    return new Types_Full(toText(printf("sensor_%s"))(name), undefined, undefined, new Types_DocKind(4, []), kind, name, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, now(), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

export function Types_Full_Encode_Z35750123(o) {
    let matchValue_2, a, a_2, matchValue_3;
    const docKind = toString_2(o.DocKind).toUpperCase();
    const probeKind = (sensor) => {
        if (sensor == null) {
            return undefined;
        }
        else {
            const s = value_247(sensor);
            return toString_2(s).toUpperCase();
        }
    };
    const sensorKind = toString_2(o.SensorKind).toUpperCase();
    const s1 = probeKind(o.S1);
    const s2 = probeKind(o.S2);
    const s3 = probeKind(o.S3);
    const s4 = probeKind(o.S4);
    const s5 = probeKind(o.S5);
    const s6 = probeKind(o.S6);
    const s7 = probeKind(o.S7);
    const s8 = probeKind(o.S8);
    const s9 = probeKind(o.S9);
    const s10 = probeKind(o.S10);
    let lastCall;
    const matchValue = o.LastCall;
    lastCall = ((matchValue == null) ? undefined : toString_1(matchValue, "O", {}));
    let birthday;
    const matchValue_1 = o.Birthday;
    birthday = ((matchValue_1 == null) ? undefined : toString_1(matchValue_1, "O", {}));
    const encodeCalibration = (calib) => ((name) => {
        if (calib == null) {
            return (input_4) => Encoder_custom(name, undefined, input_4);
        }
        else {
            const a_3 = some(Types_Calibration_Encoder_3B585444(calib));
            return (input_3) => Encoder_custom(name, a_3, input_3);
        }
    });
    const encodeCumulParameters = (cumul) => ((name_1) => {
        if (cumul == null) {
            return (input_6) => Encoder_custom(name_1, undefined, input_6);
        }
        else {
            const a_5 = some(Types_CumulParameters_Encode_Z2D7889CA(cumul));
            return (input_5) => Encoder_custom(name_1, a_5, input_5);
        }
    });
    const encodeInterpolation = (interp) => ((name_2) => {
        if (interp == null) {
            return (input_8) => Encoder_custom(name_2, undefined, input_8);
        }
        else {
            const a_7 = some(Types_Interpolation_Encoder_165A9DE4(interp));
            return (input_7) => Encoder_custom(name_2, a_7, input_7);
        }
    });
    const encodeCoeff = (interp_1) => ((name_3) => {
        if (interp_1 == null) {
            return (input_10) => Encoder_custom(name_3, undefined, input_10);
        }
        else {
            const a_9 = some(Types_Coeff_Encoder_1C10E647(interp_1));
            return (input_9) => Encoder_custom(name_3, a_9, input_9);
        }
    });
    return Encoder_toPlainJsObj(Encoder_string(new Encoder_FieldCheck(1, []), "tag", o.Tag, Encoder_bool(new Encoder_FieldCheck(1, []), "isDead", o.IsDead, Encoder_bool(new Encoder_FieldCheck(1, []), "isBeta", o.IsBeta, ((matchValue_2 = o.Alarm, (matchValue_2 == null) ? ((input_1) => Encoder_custom("alarm", undefined, input_1)) : ((a = some(Types_Alarm_Encode_1C7BB4FD(matchValue_2)), (input) => Encoder_custom("alarm", a, input)))))(Encoder_list(new Encoder_FieldCheck(1, []), "checkedWeeks", o.CheckedWeeks, undefined, Encoder_int(new Encoder_FieldCheck(1, []), "renewalInterval", o.RenewalInterval, ((a_2 = some(Types_LoiDeChauffe_Encode_550040FC(o.LoiDeChauffe)), (input_2) => Encoder_custom("loiDeChauffe", a_2, input_2)))(Encoder_bool(new Encoder_FieldCheck(1, []), "CheckPowerLoss", o.CheckPowerLoss, Encoder_bool(new Encoder_FieldCheck(1, []), "ldcv2", o.Ldcv2, Encoder_bool(new Encoder_FieldCheck(1, []), "EtalonLDC", o.EtalonLDC, Encoder_int(new Encoder_FieldCheck(1, []), "VAKind", o.VAKind, Encoder_string(new Encoder_FieldCheck(1, []), "twimmToken", o.TwimmToken, Encoder_string(new Encoder_FieldCheck(1, []), "twimmOutboundCall", o.TwimmCall, Encoder_bool(new Encoder_FieldCheck(1, []), "cumulated", o.Cumulated, Encoder_string(new Encoder_FieldCheck(1, []), "birthday", birthday, Encoder_int(new Encoder_FieldCheck(1, []), "endOfLife", o.EndOfLife, Encoder_bool(new Encoder_FieldCheck(1, []), "resumeWork", o.ResumeWork, Encoder_bool(new Encoder_FieldCheck(1, []), "isBackToWork", o.IsBackToWork, Encoder_list(new Encoder_FieldCheck(1, []), "schedule", (matchValue_3 = o.Schedule, (matchValue_3 != null) ? map(Types_ScheduleDay_Encode_Z57C96D89, matchValue_3) : undefined), undefined, Encoder_list(new Encoder_FieldCheck(1, []), "sensorOptions", o.SensorOptions, undefined, Encoder_int(new Encoder_FieldCheck(1, []), "sharePass", o.SharePass, Encoder_string(new Encoder_FieldCheck(1, []), "shareCode", o.ShareCode, Encoder_string(new Encoder_FieldCheck(1, []), "shareKey", o.ShareKey, Encoder_string(new Encoder_FieldCheck(1, []), "lastCall", lastCall, Encoder_bool(new Encoder_FieldCheck(1, []), "writeAccess", o.WriteAccess, Encoder_string(new Encoder_FieldCheck(1, []), "ownerWeb", o.OwnerWeb, Encoder_string(new Encoder_FieldCheck(1, []), "ownerName", o.OwnerName, encodeCumulParameters(o.S10CumulParameters)("s10CumulParameters")(encodeCumulParameters(o.S9CumulParameters)("s9CumulParameters")(encodeCumulParameters(o.S8CumulParameters)("s8CumulParameters")(encodeCumulParameters(o.S7CumulParameters)("s7CumulParameters")(encodeCumulParameters(o.S6CumulParameters)("s6CumulParameters")(encodeCumulParameters(o.S5CumulParameters)("s5CumulParameters")(encodeCumulParameters(o.S4CumulParameters)("s4CumulParameters")(encodeCumulParameters(o.S3CumulParameters)("s3CumulParameters")(encodeCumulParameters(o.S2CumulParameters)("s2CumulParameters")(encodeCumulParameters(o.S1CumulParameters)("s1CumulParameters")(encodeCoeff(o.S10Coeff)("s10Coeff")(encodeCoeff(o.S9Coeff)("s9Coeff")(encodeCoeff(o.S8Coeff)("s8Coeff")(encodeCoeff(o.S7Coeff)("s7Coeff")(encodeCoeff(o.S6Coeff)("s6Coeff")(encodeCoeff(o.S5Coeff)("s5Coeff")(encodeCoeff(o.S4Coeff)("s4Coeff")(encodeCoeff(o.S3Coeff)("s3Coeff")(encodeCoeff(o.S2Coeff)("s2Coeff")(encodeCoeff(o.S1Coeff)("s1Coeff")(encodeInterpolation(o.S10Interpolation)("s10Interpolation")(encodeInterpolation(o.S9Interpolation)("s9Interpolation")(encodeInterpolation(o.S8Interpolation)("s8Interpolation")(encodeInterpolation(o.S7Interpolation)("s7Interpolation")(encodeInterpolation(o.S6Interpolation)("s6Interpolation")(encodeInterpolation(o.S5Interpolation)("s5Interpolation")(encodeInterpolation(o.S4Interpolation)("s4Interpolation")(encodeInterpolation(o.S3Interpolation)("s3Interpolation")(encodeInterpolation(o.S2Interpolation)("s2Interpolation")(encodeInterpolation(o.S1Interpolation)("s1Interpolation")(encodeCalibration(o.S10Calibration)("s10Calibration")(encodeCalibration(o.S9Calibration)("s9Calibration")(encodeCalibration(o.S8Calibration)("s8Calibration")(encodeCalibration(o.S7Calibration)("s7Calibration")(encodeCalibration(o.S6Calibration)("s6Calibration")(encodeCalibration(o.S5Calibration)("s5Calibration")(encodeCalibration(o.S4Calibration)("s4Calibration")(encodeCalibration(o.S3Calibration)("s3Calibration")(encodeCalibration(o.S2Calibration)("s2Calibration")(encodeCalibration(o.S1Calibration)("s1Calibration")(Encoder_bool(new Encoder_FieldCheck(1, []), "s10Active", o.S10Activated, Encoder_bool(new Encoder_FieldCheck(1, []), "s9Active", o.S9Activated, Encoder_bool(new Encoder_FieldCheck(1, []), "s8Active", o.S8Activated, Encoder_bool(new Encoder_FieldCheck(1, []), "s7Active", o.S7Activated, Encoder_bool(new Encoder_FieldCheck(1, []), "s6Active", o.S6Activated, Encoder_bool(new Encoder_FieldCheck(1, []), "s5Active", o.S5Activated, Encoder_bool(new Encoder_FieldCheck(1, []), "s4Active", o.S4Activated, Encoder_bool(new Encoder_FieldCheck(1, []), "s3Active", o.S3Activated, Encoder_bool(new Encoder_FieldCheck(1, []), "s2Active", o.S2Activated, Encoder_bool(new Encoder_FieldCheck(1, []), "s1Active", o.S1Activated, Encoder_string(new Encoder_FieldCheck(1, []), "s10Title", o.S10Title, Encoder_string(new Encoder_FieldCheck(1, []), "s9Title", o.S9Title, Encoder_string(new Encoder_FieldCheck(1, []), "s8Title", o.S8Title, Encoder_string(new Encoder_FieldCheck(1, []), "s7Title", o.S7Title, Encoder_string(new Encoder_FieldCheck(1, []), "s6Title", o.S6Title, Encoder_string(new Encoder_FieldCheck(1, []), "s5Title", o.S5Title, Encoder_string(new Encoder_FieldCheck(1, []), "s4Title", o.S4Title, Encoder_string(new Encoder_FieldCheck(1, []), "s3Title", o.S3Title, Encoder_string(new Encoder_FieldCheck(1, []), "s2Title", o.S2Title, Encoder_string(new Encoder_FieldCheck(1, []), "s1Title", o.S1Title, Encoder_string(new Encoder_FieldCheck(1, []), "s10", s10, Encoder_string(new Encoder_FieldCheck(1, []), "s9", s9, Encoder_string(new Encoder_FieldCheck(1, []), "s8", s8, Encoder_string(new Encoder_FieldCheck(1, []), "s7", s7, Encoder_string(new Encoder_FieldCheck(1, []), "s6", s6, Encoder_string(new Encoder_FieldCheck(1, []), "s5", s5, Encoder_string(new Encoder_FieldCheck(1, []), "s4", s4, Encoder_string(new Encoder_FieldCheck(1, []), "s3", s3, Encoder_string(new Encoder_FieldCheck(1, []), "s2", s2, Encoder_string(new Encoder_FieldCheck(1, []), "s1", s1, Encoder_string(new Encoder_FieldCheck(1, []), "title", o.Title, Encoder_string(new Encoder_FieldCheck(0, []), "contract", o.Contract, Encoder_string(new Encoder_FieldCheck(0, []), "name", o.Name, Encoder_string(new Encoder_FieldCheck(0, []), "sensorKind", sensorKind, Encoder_string(new Encoder_FieldCheck(0, []), "docKind", docKind, Encoder_bool(new Encoder_FieldCheck(1, []), "_deleted", o.Deleted, Encoder_string(new Encoder_FieldCheck(1, []), "_rev", o.Rev, Encoder_string(new Encoder_FieldCheck(0, []), "_id", o.Id, Encoder_empty))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
}

export function Types_Full_EncodeForCouch_Z35750123(o) {
    let deleted, rev_1, rev;
    const docKind = toString_2(o.DocKind).toUpperCase();
    const probeKind = (sensor) => {
        if (sensor == null) {
            return undefined;
        }
        else {
            const s = value_247(sensor);
            return toString_2(s).toUpperCase();
        }
    };
    const sensorKind = toString_2(o.SensorKind).toUpperCase();
    const s1 = probeKind(o.S1);
    const s2 = probeKind(o.S2);
    const s3 = probeKind(o.S3);
    const s4 = probeKind(o.S4);
    const s5 = probeKind(o.S5);
    const s6 = probeKind(o.S6);
    const s7 = probeKind(o.S7);
    const s8 = probeKind(o.S8);
    const s9 = probeKind(o.S9);
    const s10 = probeKind(o.S10);
    const activated = (s_1) => {
        if (s_1 == null) {
            return false;
        }
        else if (s_1) {
            return true;
        }
        else {
            return false;
        }
    };
    const activatedS1 = activated(o.S1Activated);
    const activatedS2 = activated(o.S2Activated);
    const activatedS3 = activated(o.S3Activated);
    const activatedS4 = activated(o.S4Activated);
    const activatedS5 = activated(o.S5Activated);
    const activatedS6 = activated(o.S6Activated);
    const activatedS7 = activated(o.S7Activated);
    const activatedS8 = activated(o.S8Activated);
    const activatedS9 = activated(o.S9Activated);
    const activatedS10 = activated(o.S10Activated);
    let alarm_1;
    const matchValue = o.Alarm;
    alarm_1 = ((matchValue == null) ? nil : Types_Alarm_EncodeForCouch_1C7BB4FD(matchValue));
    const loiDeChauffe = Types_LoiDeChauffe_EncodeForCouch_550040FC(o.LoiDeChauffe);
    let headers;
    const matchValue_1 = o.Rev;
    const matchValue_2 = o.Deleted;
    headers = ((matchValue_1 != null) ? ((matchValue_2 != null) ? ((deleted = matchValue_2, (rev_1 = matchValue_1, ofArray([["_rev", rev_1], ["_deleted", deleted]])))) : ((rev = matchValue_1, singleton(["_rev", rev])))) : empty());
    let sensorOptions;
    const matchValue_4 = o.SensorOptions;
    sensorOptions = ((matchValue_4 == null) ? nil : list_6(map((o_3) => toString_2(o_3).toUpperCase(), matchValue_4)));
    let checkedWeeks;
    const matchValue_5 = o.CheckedWeeks;
    checkedWeeks = ((matchValue_5 == null) ? nil : list_6(map((value_5) => value_5, matchValue_5)));
    let schedule;
    const matchValue_6 = o.Schedule;
    schedule = ((matchValue_6 == null) ? nil : list_6(map(Types_ScheduleDay_EncodeForPouch_Z57C96D89, matchValue_6)));
    return toString_3(0, object(append(headers, ofArray([["_id", o.Id], ["docKind", docKind], ["sensorKind", sensorKind], ["name", o.Name], ["contract", o.Contract], ["title", option_101((value_12) => value_12)(o.Title)], ["s1", option_101((value_14) => value_14)(s1)], ["s2", option_101((value_16) => value_16)(s2)], ["s3", option_101((value_18) => value_18)(s3)], ["s4", option_101((value_20) => value_20)(s4)], ["s5", option_101((value_22) => value_22)(s5)], ["s6", option_101((value_24) => value_24)(s6)], ["s7", option_101((value_26) => value_26)(s7)], ["s8", option_101((value_28) => value_28)(s8)], ["s9", option_101((value_30) => value_30)(s9)], ["s10", option_101((value_32) => value_32)(s10)], ["s1Active", option_101((value_34) => value_34)(activatedS1)], ["s2Active", option_101((value_36) => value_36)(activatedS2)], ["s3Active", option_101((value_38) => value_38)(activatedS3)], ["s4Active", option_101((value_40) => value_40)(activatedS4)], ["s5Active", option_101((value_42) => value_42)(activatedS5)], ["s6Active", option_101((value_44) => value_44)(activatedS6)], ["s7Active", option_101((value_46) => value_46)(activatedS7)], ["s8Active", option_101((value_48) => value_48)(activatedS8)], ["s9Active", option_101((value_50) => value_50)(activatedS9)], ["s10Active", option_101((value_52) => value_52)(activatedS10)], ["s1Title", option_101((value_54) => value_54)(o.S1Title)], ["s2Title", option_101((value_56) => value_56)(o.S2Title)], ["s3Title", option_101((value_58) => value_58)(o.S3Title)], ["s4Title", option_101((value_60) => value_60)(o.S4Title)], ["s5Title", option_101((value_62) => value_62)(o.S5Title)], ["s6Title", option_101((value_64) => value_64)(o.S6Title)], ["s7Title", option_101((value_66) => value_66)(o.S7Title)], ["s8Title", option_101((value_68) => value_68)(o.S8Title)], ["s9Title", option_101((value_70) => value_70)(o.S9Title)], ["s10Title", option_101((value_72) => value_72)(o.S10Title)], ["ownerWeb", option_101((value_74) => value_74)(o.OwnerWeb)], ["ownerName", option_101((value_76) => value_76)(o.OwnerName)], ["lastCall", option_101(datetime_1)(o.LastCall)], ["s1Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S1Calibration)], ["s2Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S2Calibration)], ["s3Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S3Calibration)], ["s4Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S4Calibration)], ["s5Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S5Calibration)], ["s6Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S6Calibration)], ["s7Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S7Calibration)], ["s8Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S8Calibration)], ["s9Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S9Calibration)], ["s10Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S10Calibration)], ["s1Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S1Interpolation)], ["s2Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S2Interpolation)], ["s3Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S3Interpolation)], ["s4Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S4Interpolation)], ["s5Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S5Interpolation)], ["s6Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S6Interpolation)], ["s7Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S7Interpolation)], ["s8Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S8Interpolation)], ["s9Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S9Interpolation)], ["s10Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S10Interpolation)], ["s1Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S1Coeff)], ["s2Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S2Coeff)], ["s3Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S3Coeff)], ["s4Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S4Coeff)], ["s5Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S5Coeff)], ["s6Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S6Coeff)], ["s7Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S7Coeff)], ["s8Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S8Coeff)], ["s9Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S9Coeff)], ["s10Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S10Coeff)], ["s1CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S1CumulParameters)], ["s2CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S2CumulParameters)], ["s3CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S3CumulParameters)], ["s4CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S4CumulParameters)], ["s5CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S5CumulParameters)], ["s6CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S6CumulParameters)], ["s7CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S7CumulParameters)], ["s8CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S8CumulParameters)], ["s9CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S9CumulParameters)], ["s10CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S10CumulParameters)], ["shareKey", option_101((value_79) => value_79)(o.ShareKey)], ["shareCode", option_101((value_81) => value_81)(o.ShareCode)], ["sharePass", option_101((value_83) => value_83)(o.SharePass)], ["alarm", alarm_1], ["schedule", schedule], ["isBackToWork", option_101((value_85) => value_85)(o.IsBackToWork)], ["resumeWork", option_101((value_87) => value_87)(o.ResumeWork)], ["sensorOptions", sensorOptions], ["birthday", option_101(datetime_1)(o.Birthday)], ["endOfLife", option_101((value_90) => value_90)(o.EndOfLife)], ["cumulated", option_101((value_92) => value_92)(o.Cumulated)], ["twimmOutboundCall", option_101((value_94) => value_94)(o.TwimmCall)], ["twimmToken", option_101((value_96) => value_96)(o.TwimmToken)], ["VAKind", option_101((value_98) => value_98)(o.VAKind)], ["EtalonLDC", option_101((value_100) => value_100)(o.EtalonLDC)], ["ldcv2", option_101((value_102) => value_102)(o.Ldcv2)], ["loiDeChauffe", loiDeChauffe], ["CheckPowerLoss", option_101((value_104) => value_104)(o.CheckPowerLoss)], ["renewalInterval", option_101((value_106) => value_106)(o.RenewalInterval)], ["checkedWeeks", checkedWeeks], ["isBeta", option_101((value_108) => value_108)(o.IsBeta)], ["isDead", option_101((value_110) => value_110)(o.IsDead)], ["tag", option_101((value_112) => value_112)(o.Tag)]]))));
}

export function Types_Full_EncodeObject_Z35750123(o) {
    let deleted, rev_1, rev;
    const docKind = toString_2(o.DocKind).toUpperCase();
    const probeKind = (sensor) => {
        if (sensor == null) {
            return undefined;
        }
        else {
            const s = value_247(sensor);
            return toString_2(s).toUpperCase();
        }
    };
    const sensorKind = toString_2(o.SensorKind).toUpperCase();
    const s1 = probeKind(o.S1);
    const s2 = probeKind(o.S2);
    const s3 = probeKind(o.S3);
    const s4 = probeKind(o.S4);
    const s5 = probeKind(o.S5);
    const s6 = probeKind(o.S6);
    const s7 = probeKind(o.S7);
    const s8 = probeKind(o.S8);
    const s9 = probeKind(o.S9);
    const s10 = probeKind(o.S10);
    const activated = (s_1) => {
        if (s_1 == null) {
            return false;
        }
        else if (s_1) {
            return true;
        }
        else {
            return false;
        }
    };
    const activatedS1 = activated(o.S1Activated);
    const activatedS2 = activated(o.S2Activated);
    const activatedS3 = activated(o.S3Activated);
    const activatedS4 = activated(o.S4Activated);
    const activatedS5 = activated(o.S5Activated);
    const activatedS6 = activated(o.S6Activated);
    const activatedS7 = activated(o.S7Activated);
    const activatedS8 = activated(o.S8Activated);
    const activatedS9 = activated(o.S9Activated);
    const activatedS10 = activated(o.S10Activated);
    let alarm_1;
    const matchValue = o.Alarm;
    alarm_1 = ((matchValue == null) ? nil : Types_Alarm_EncodeForCouch_1C7BB4FD(matchValue));
    const loiDeChauffe = Types_LoiDeChauffe_EncodeForCouch_550040FC(o.LoiDeChauffe);
    let headers;
    const matchValue_1 = o.Rev;
    const matchValue_2 = o.Deleted;
    headers = ((matchValue_1 != null) ? ((matchValue_2 != null) ? ((deleted = matchValue_2, (rev_1 = matchValue_1, ofArray([["_rev", rev_1], ["_deleted", deleted]])))) : ((rev = matchValue_1, singleton(["_rev", rev])))) : empty());
    let sensorOptions;
    const matchValue_4 = o.SensorOptions;
    sensorOptions = ((matchValue_4 == null) ? nil : list_6(map((o_3) => toString_2(o_3).toUpperCase(), matchValue_4)));
    let checkedWeeks;
    const matchValue_5 = o.CheckedWeeks;
    checkedWeeks = ((matchValue_5 == null) ? nil : list_6(map((value_5) => value_5, matchValue_5)));
    let schedule;
    const matchValue_6 = o.Schedule;
    schedule = ((matchValue_6 == null) ? nil : list_6(map(Types_ScheduleDay_EncodeForPouch_Z57C96D89, matchValue_6)));
    return object(append(headers, ofArray([["_id", o.Id], ["docKind", docKind], ["sensorKind", sensorKind], ["name", o.Name], ["contract", o.Contract], ["title", option_101((value_12) => value_12)(o.Title)], ["s1", option_101((value_14) => value_14)(s1)], ["s2", option_101((value_16) => value_16)(s2)], ["s3", option_101((value_18) => value_18)(s3)], ["s4", option_101((value_20) => value_20)(s4)], ["s5", option_101((value_22) => value_22)(s5)], ["s6", option_101((value_24) => value_24)(s6)], ["s7", option_101((value_26) => value_26)(s7)], ["s8", option_101((value_28) => value_28)(s8)], ["s9", option_101((value_30) => value_30)(s9)], ["s10", option_101((value_32) => value_32)(s10)], ["s1Active", option_101((value_34) => value_34)(activatedS1)], ["s2Active", option_101((value_36) => value_36)(activatedS2)], ["s3Active", option_101((value_38) => value_38)(activatedS3)], ["s4Active", option_101((value_40) => value_40)(activatedS4)], ["s5Active", option_101((value_42) => value_42)(activatedS5)], ["s6Active", option_101((value_44) => value_44)(activatedS6)], ["s7Active", option_101((value_46) => value_46)(activatedS7)], ["s8Active", option_101((value_48) => value_48)(activatedS8)], ["s9Active", option_101((value_50) => value_50)(activatedS9)], ["s10Active", option_101((value_52) => value_52)(activatedS10)], ["s1Title", option_101((value_54) => value_54)(o.S1Title)], ["s2Title", option_101((value_56) => value_56)(o.S2Title)], ["s3Title", option_101((value_58) => value_58)(o.S3Title)], ["s4Title", option_101((value_60) => value_60)(o.S4Title)], ["s5Title", option_101((value_62) => value_62)(o.S5Title)], ["s6Title", option_101((value_64) => value_64)(o.S6Title)], ["s7Title", option_101((value_66) => value_66)(o.S7Title)], ["s8Title", option_101((value_68) => value_68)(o.S8Title)], ["s9Title", option_101((value_70) => value_70)(o.S9Title)], ["s10Title", option_101((value_72) => value_72)(o.S10Title)], ["ownerWeb", option_101((value_74) => value_74)(o.OwnerWeb)], ["ownerName", option_101((value_76) => value_76)(o.OwnerName)], ["lastCall", option_101(datetime_1)(o.LastCall)], ["s1Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S1Calibration)], ["s2Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S2Calibration)], ["s3Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S3Calibration)], ["s4Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S4Calibration)], ["s5Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S5Calibration)], ["s6Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S6Calibration)], ["s7Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S7Calibration)], ["s8Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S8Calibration)], ["s9Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S9Calibration)], ["s10Calibration", option_101(Types_Calibration_Encode_3B585444)(o.S10Calibration)], ["s1Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S1Interpolation)], ["s2Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S2Interpolation)], ["s3Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S3Interpolation)], ["s4Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S4Interpolation)], ["s5Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S5Interpolation)], ["s6Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S6Interpolation)], ["s7Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S7Interpolation)], ["s8Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S8Interpolation)], ["s9Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S9Interpolation)], ["s10Interpolation", option_101(Types_Interpolation_Encode_165A9DE4)(o.S10Interpolation)], ["s1Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S1Coeff)], ["s2Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S2Coeff)], ["s3Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S3Coeff)], ["s4Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S4Coeff)], ["s5Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S5Coeff)], ["s6Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S6Coeff)], ["s7Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S7Coeff)], ["s8Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S8Coeff)], ["s9Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S9Coeff)], ["s10Coeff", option_101(Types_Coeff_Encode_1C10E647)(o.S10Coeff)], ["s1CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S1CumulParameters)], ["s2CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S2CumulParameters)], ["s3CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S3CumulParameters)], ["s4CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S4CumulParameters)], ["s5CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S5CumulParameters)], ["s6CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S6CumulParameters)], ["s7CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S7CumulParameters)], ["s8CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S8CumulParameters)], ["s9CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S9CumulParameters)], ["s10CumulParameters", option_101(Types_CumulParameters_Encode_Z2D7889CA)(o.S10CumulParameters)], ["shareKey", option_101((value_79) => value_79)(o.ShareKey)], ["shareCode", option_101((value_81) => value_81)(o.ShareCode)], ["sharePass", option_101((value_83) => value_83)(o.SharePass)], ["alarm", alarm_1], ["schedule", schedule], ["isBackToWork", option_101((value_85) => value_85)(o.IsBackToWork)], ["resumeWork", option_101((value_87) => value_87)(o.ResumeWork)], ["sensorOptions", sensorOptions], ["birthday", option_101(datetime_1)(o.Birthday)], ["endOfLife", option_101((value_90) => value_90)(o.EndOfLife)], ["cumulated", option_101((value_92) => value_92)(o.Cumulated)], ["twimmOutboundCall", option_101((value_94) => value_94)(o.TwimmCall)], ["twimmToken", option_101((value_96) => value_96)(o.TwimmToken)], ["VAKind", option_101((value_98) => value_98)(o.VAKind)], ["EtalonLDC", option_101((value_100) => value_100)(o.EtalonLDC)], ["ldcv2", option_101((value_102) => value_102)(o.Ldcv2)], ["loiDeChauffe", loiDeChauffe], ["CheckPowerLoss", option_101((value_104) => value_104)(o.CheckPowerLoss)], ["renewalInterval", option_101((value_106) => value_106)(o.RenewalInterval)], ["checkedWeeks", checkedWeeks], ["isBeta", option_101((value_108) => value_108)(o.IsBeta)], ["isDead", option_101((value_110) => value_110)(o.IsDead)], ["tag", option_101((value_112) => value_112)(o.Tag)]])));
}

export function Types_Full_getProbeName(probe, sensor) {
    const realName = (kind, title, interp, coeff, i) => {
        let t_1;
        if (title == null) {
            if (kind == null) {
                t_1 = toText(printf("sonde %i"))(i);
            }
            else {
                const k = kind;
                const arg_1 = Types_ProbeKind_get_toLabel()(k);
                t_1 = toText(printf("sonde %i : %s"))(i)(arg_1);
            }
        }
        else {
            t_1 = title;
        }
        if (interp != null) {
            if (coeff != null) {
                const interp_2 = interp;
                return toText(printf("%s (%s)"))(t_1)(interp_2.Unit);
            }
            else {
                const interp_1 = interp;
                return toText(printf("%s (%s)"))(t_1)(interp_1.Unit);
            }
        }
        else if (coeff == null) {
            return t_1;
        }
        else {
            const coeff_1 = coeff;
            return toText(printf("%s (%s)"))(t_1)(coeff_1.Unit);
        }
    };
    switch (probe) {
        case "sensor.s1":
            return realName(sensor.S1, sensor.S1Title, sensor.S1Interpolation, sensor.S1Coeff, 1);
        case "sensor.s2":
            return realName(sensor.S2, sensor.S2Title, sensor.S2Interpolation, sensor.S2Coeff, 2);
        case "sensor.s3":
            return realName(sensor.S3, sensor.S3Title, sensor.S3Interpolation, sensor.S3Coeff, 3);
        case "sensor.s4":
            return realName(sensor.S4, sensor.S4Title, sensor.S4Interpolation, sensor.S4Coeff, 4);
        case "sensor.s5":
            return realName(sensor.S5, sensor.S5Title, sensor.S5Interpolation, sensor.S5Coeff, 5);
        case "sensor.s6":
            return realName(sensor.S6, sensor.S6Title, sensor.S6Interpolation, sensor.S6Coeff, 6);
        case "sensor.s7":
            return realName(sensor.S7, sensor.S7Title, sensor.S7Interpolation, sensor.S7Coeff, 7);
        case "sensor.s8":
            return realName(sensor.S8, sensor.S8Title, sensor.S8Interpolation, sensor.S8Coeff, 8);
        case "sensor.s9":
            return realName(sensor.S9, sensor.S9Title, sensor.S9Interpolation, sensor.S9Coeff, 9);
        case "sensor.s10":
            return realName(sensor.S10, sensor.S10Title, sensor.S10Interpolation, sensor.S10Coeff, 10);
        case "sensor.battery":
            return "pile (V.dc)";
        case "sensor.rssi":
            return "rssi";
        default:
            return probe;
    }
}

export function Types_Full_getProbeKind(probe, sensor) {
    switch (probe) {
        case "sensor.s1":
            return sensor.S1;
        case "sensor.s2":
            return sensor.S2;
        case "sensor.s3":
            return sensor.S3;
        case "sensor.s4":
            return sensor.S4;
        case "sensor.s5":
            return sensor.S5;
        case "sensor.s6":
            return sensor.S6;
        case "sensor.s7":
            return sensor.S7;
        case "sensor.s8":
            return sensor.S8;
        case "sensor.s9":
            return sensor.S9;
        case "sensor.s10":
            return sensor.S10;
        case "sensor.battery":
            return new Types_ProbeKind(11, []);
        case "sensor.rssi":
            return new Types_ProbeKind(19, []);
        default:
            return new Types_ProbeKind(11, []);
    }
}

export function Types_Full_getInterpolation(probe, sensor) {
    switch (probe) {
        case "sensor.s1":
            return sensor.S1Interpolation;
        case "sensor.s2":
            return sensor.S2Interpolation;
        case "sensor.s3":
            return sensor.S3Interpolation;
        case "sensor.s4":
            return sensor.S4Interpolation;
        case "sensor.s5":
            return sensor.S5Interpolation;
        case "sensor.s6":
            return sensor.S6Interpolation;
        case "sensor.s7":
            return sensor.S7Interpolation;
        case "sensor.s8":
            return sensor.S8Interpolation;
        case "sensor.s9":
            return sensor.S9Interpolation;
        case "sensor.s10":
            return sensor.S10Interpolation;
        default:
            return undefined;
    }
}

export function Types_Full_getCoeff(probe, sensor) {
    switch (probe) {
        case "sensor.s1":
            return sensor.S1Coeff;
        case "sensor.s2":
            return sensor.S2Coeff;
        case "sensor.s3":
            return sensor.S3Coeff;
        case "sensor.s4":
            return sensor.S4Coeff;
        case "sensor.s5":
            return sensor.S5Coeff;
        case "sensor.s6":
            return sensor.S6Coeff;
        case "sensor.s7":
            return sensor.S7Coeff;
        case "sensor.s8":
            return sensor.S8Coeff;
        case "sensor.s9":
            return sensor.S9Coeff;
        case "sensor.s10":
            return sensor.S10Coeff;
        default:
            return undefined;
    }
}

export function Types_Full_getCumuParameters(probe, sensor) {
    switch (probe) {
        case "sensor.s1":
            return sensor.S1CumulParameters;
        case "sensor.s2":
            return sensor.S2CumulParameters;
        case "sensor.s3":
            return sensor.S3CumulParameters;
        case "sensor.s4":
            return sensor.S4CumulParameters;
        case "sensor.s5":
            return sensor.S5CumulParameters;
        case "sensor.s6":
            return sensor.S6CumulParameters;
        case "sensor.s7":
            return sensor.S7CumulParameters;
        case "sensor.s8":
            return sensor.S8CumulParameters;
        case "sensor.s9":
            return sensor.S9CumulParameters;
        case "sensor.s10":
            return sensor.S10CumulParameters;
        default:
            return undefined;
    }
}

export function Types_Full_get_Decoder() {
    return (path_147) => ((v) => object_1((get$) => {
        let objectArg_1, objectArg_2, arg_15, decoder_2, objectArg_7, arg_17, decoder_3, objectArg_8, arg_19, decoder_4, objectArg_9, arg_21, decoder_5, objectArg_10, arg_23, decoder_6, objectArg_11, arg_25, decoder_7, objectArg_12, arg_27, decoder_8, objectArg_13, arg_29, decoder_9, objectArg_14, arg_31, decoder_10, objectArg_15, arg_33, decoder_11, objectArg_16, objectArg_17, objectArg_18, objectArg_19, objectArg_20, objectArg_21, objectArg_22, objectArg_23, objectArg_24, objectArg_25, objectArg_26, objectArg_27, objectArg_28, objectArg_29, objectArg_30, objectArg_31, objectArg_32, objectArg_33, objectArg_34, objectArg_35, objectArg_36, objectArg_37, objectArg_38, objectArg_39, arg_81, decoder_35, objectArg_40, objectArg_41, objectArg_42, arg_87, decoder_38, objectArg_43, arg_89, decoder_39, objectArg_44, arg_91, decoder_40, objectArg_45, arg_93, decoder_41, objectArg_46, arg_95, decoder_42, objectArg_47, arg_97, decoder_43, objectArg_48, arg_99, decoder_44, objectArg_49, arg_101, decoder_45, objectArg_50, arg_103, decoder_46, objectArg_51, arg_105, decoder_47, objectArg_52, arg_107, decoder_48, objectArg_53, arg_109, decoder_49, objectArg_54, arg_111, decoder_50, objectArg_55, arg_113, decoder_51, objectArg_56, arg_115, decoder_52, objectArg_57, arg_117, decoder_53, objectArg_58, arg_119, decoder_54, objectArg_59, arg_121, decoder_55, objectArg_60, arg_123, decoder_56, objectArg_61, arg_125, decoder_57, objectArg_62, arg_127, decoder_58, objectArg_63, arg_129, decoder_59, objectArg_64, arg_131, decoder_60, objectArg_65, arg_133, decoder_61, objectArg_66, arg_135, decoder_62, objectArg_67, arg_137, decoder_63, objectArg_68, arg_139, decoder_64, objectArg_69, arg_141, decoder_65, objectArg_70, arg_143, decoder_66, objectArg_71, arg_145, decoder_67, objectArg_72, arg_147, decoder_68, objectArg_73, arg_149, decoder_69, objectArg_74, arg_151, decoder_70, objectArg_75, arg_153, decoder_71, objectArg_76, arg_155, decoder_72, objectArg_77, arg_157, decoder_73, objectArg_78, arg_159, decoder_74, objectArg_79, arg_161, decoder_75, objectArg_80, arg_163, decoder_76, objectArg_81, arg_165, decoder_77, objectArg_82, objectArg_83, objectArg_84, objectArg_85, arg_173, decoder_82, decoder_81, objectArg_86, arg_175, decoder_84, decoder_83, objectArg_87, objectArg_88, objectArg_89, objectArg_90, objectArg_91, objectArg_92, objectArg_93, objectArg_94, objectArg_95, objectArg_96, objectArg_97, objectArg_98, arg_199, decoder_96, objectArg_99, objectArg_100, objectArg_101, objectArg_102, objectArg_103, objectArg_104;
        let Id;
        const objectArg = get$.Required;
        Id = objectArg.Field("_id", string);
        const Rev = defaultArg((objectArg_1 = get$.Optional, objectArg_1.Field("_rev", (path_2, value_2) => option_100(string, path_2, value_2))), undefined);
        const Deleted = defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("_deleted", (path_4, value_5) => option_100(bool, path_4, value_5))), undefined);
        let DocKind;
        const objectArg_3 = get$.Required;
        DocKind = objectArg_3.Field("docKind", uncurry2(Types_Helpers_decodeDocKind));
        let SensorKind;
        const arg_9 = Types_SensorKind_get_decode();
        const objectArg_4 = get$.Required;
        SensorKind = objectArg_4.Field("sensorKind", uncurry2(arg_9));
        let Name;
        const objectArg_5 = get$.Required;
        Name = objectArg_5.Field("name", string);
        let Contract;
        const objectArg_6 = get$.Required;
        Contract = objectArg_6.Field("contract", string);
        const S = defaultArg((arg_15 = ((decoder_2 = Types_ProbeKind_get_decode(), (path_7) => ((value_9) => option_100(uncurry2(decoder_2), path_7, value_9)))), (objectArg_7 = get$.Optional, objectArg_7.Field("s1", uncurry2(arg_15)))), undefined);
        const S_1 = defaultArg((arg_17 = ((decoder_3 = Types_ProbeKind_get_decode(), (path_8) => ((value_11) => option_100(uncurry2(decoder_3), path_8, value_11)))), (objectArg_8 = get$.Optional, objectArg_8.Field("s2", uncurry2(arg_17)))), undefined);
        const S_2 = defaultArg((arg_19 = ((decoder_4 = Types_ProbeKind_get_decode(), (path_9) => ((value_13) => option_100(uncurry2(decoder_4), path_9, value_13)))), (objectArg_9 = get$.Optional, objectArg_9.Field("s3", uncurry2(arg_19)))), undefined);
        const S_3 = defaultArg((arg_21 = ((decoder_5 = Types_ProbeKind_get_decode(), (path_10) => ((value_15) => option_100(uncurry2(decoder_5), path_10, value_15)))), (objectArg_10 = get$.Optional, objectArg_10.Field("s4", uncurry2(arg_21)))), undefined);
        const S_4 = defaultArg((arg_23 = ((decoder_6 = Types_ProbeKind_get_decode(), (path_11) => ((value_17) => option_100(uncurry2(decoder_6), path_11, value_17)))), (objectArg_11 = get$.Optional, objectArg_11.Field("s5", uncurry2(arg_23)))), undefined);
        const S_5 = defaultArg((arg_25 = ((decoder_7 = Types_ProbeKind_get_decode(), (path_12) => ((value_19) => option_100(uncurry2(decoder_7), path_12, value_19)))), (objectArg_12 = get$.Optional, objectArg_12.Field("s6", uncurry2(arg_25)))), undefined);
        const S_6 = defaultArg((arg_27 = ((decoder_8 = Types_ProbeKind_get_decode(), (path_13) => ((value_21) => option_100(uncurry2(decoder_8), path_13, value_21)))), (objectArg_13 = get$.Optional, objectArg_13.Field("s7", uncurry2(arg_27)))), undefined);
        const S_7 = defaultArg((arg_29 = ((decoder_9 = Types_ProbeKind_get_decode(), (path_14) => ((value_23) => option_100(uncurry2(decoder_9), path_14, value_23)))), (objectArg_14 = get$.Optional, objectArg_14.Field("s8", uncurry2(arg_29)))), undefined);
        const S_8 = defaultArg((arg_31 = ((decoder_10 = Types_ProbeKind_get_decode(), (path_15) => ((value_25) => option_100(uncurry2(decoder_10), path_15, value_25)))), (objectArg_15 = get$.Optional, objectArg_15.Field("s9", uncurry2(arg_31)))), undefined);
        const S_9 = defaultArg((arg_33 = ((decoder_11 = Types_ProbeKind_get_decode(), (path_16) => ((value_27) => option_100(uncurry2(decoder_11), path_16, value_27)))), (objectArg_16 = get$.Optional, objectArg_16.Field("s10", uncurry2(arg_33)))), undefined);
        const S1Activated = defaultArg((objectArg_17 = get$.Optional, objectArg_17.Field("s1Active", (path_18, value_30) => option_100(bool, path_18, value_30))), false);
        const S2Activated = defaultArg((objectArg_18 = get$.Optional, objectArg_18.Field("s2Active", (path_20, value_33) => option_100(bool, path_20, value_33))), false);
        const S3Activated = defaultArg((objectArg_19 = get$.Optional, objectArg_19.Field("s3Active", (path_22, value_36) => option_100(bool, path_22, value_36))), false);
        const S4Activated = defaultArg((objectArg_20 = get$.Optional, objectArg_20.Field("s4Active", (path_24, value_39) => option_100(bool, path_24, value_39))), false);
        const S5Activated = defaultArg((objectArg_21 = get$.Optional, objectArg_21.Field("s5Active", (path_26, value_42) => option_100(bool, path_26, value_42))), false);
        const S6Activated = defaultArg((objectArg_22 = get$.Optional, objectArg_22.Field("s6Active", (path_28, value_45) => option_100(bool, path_28, value_45))), false);
        const S7Activated = defaultArg((objectArg_23 = get$.Optional, objectArg_23.Field("s7Active", (path_30, value_48) => option_100(bool, path_30, value_48))), false);
        const S8Activated = defaultArg((objectArg_24 = get$.Optional, objectArg_24.Field("s8Active", (path_32, value_51) => option_100(bool, path_32, value_51))), false);
        const S9Activated = defaultArg((objectArg_25 = get$.Optional, objectArg_25.Field("s9Active", (path_34, value_54) => option_100(bool, path_34, value_54))), false);
        const S10Activated = defaultArg((objectArg_26 = get$.Optional, objectArg_26.Field("s10Active", (path_36, value_57) => option_100(bool, path_36, value_57))), false);
        const Title = defaultArg((objectArg_27 = get$.Optional, objectArg_27.Field("title", (path_38, value_60) => option_100(string, path_38, value_60))), undefined);
        const S1Title = defaultArg((objectArg_28 = get$.Optional, objectArg_28.Field("s1Title", (path_40, value_63) => option_100(string, path_40, value_63))), undefined);
        const S2Title = defaultArg((objectArg_29 = get$.Optional, objectArg_29.Field("s2Title", (path_42, value_66) => option_100(string, path_42, value_66))), undefined);
        const S3Title = defaultArg((objectArg_30 = get$.Optional, objectArg_30.Field("s3Title", (path_44, value_69) => option_100(string, path_44, value_69))), undefined);
        const S4Title = defaultArg((objectArg_31 = get$.Optional, objectArg_31.Field("s4Title", (path_46, value_72) => option_100(string, path_46, value_72))), undefined);
        const S5Title = defaultArg((objectArg_32 = get$.Optional, objectArg_32.Field("s5Title", (path_48, value_75) => option_100(string, path_48, value_75))), undefined);
        const S6Title = defaultArg((objectArg_33 = get$.Optional, objectArg_33.Field("s6Title", (path_50, value_78) => option_100(string, path_50, value_78))), undefined);
        const S7Title = defaultArg((objectArg_34 = get$.Optional, objectArg_34.Field("s7Title", (path_52, value_81) => option_100(string, path_52, value_81))), undefined);
        const S8Title = defaultArg((objectArg_35 = get$.Optional, objectArg_35.Field("s8Title", (path_54, value_84) => option_100(string, path_54, value_84))), undefined);
        const S9Title = defaultArg((objectArg_36 = get$.Optional, objectArg_36.Field("s9Title", (path_56, value_87) => option_100(string, path_56, value_87))), undefined);
        const S10Title = defaultArg((objectArg_37 = get$.Optional, objectArg_37.Field("s10Title", (path_58, value_90) => option_100(string, path_58, value_90))), undefined);
        const OwnerWeb = defaultArg((objectArg_38 = get$.Optional, objectArg_38.Field("ownerWeb", (path_60, value_93) => option_100(string, path_60, value_93))), undefined);
        const OwnerName = defaultArg((objectArg_39 = get$.Optional, objectArg_39.Field("ownerName", (path_62, value_96) => option_100(string, path_62, value_96))), undefined);
        const Alarm = defaultArg((arg_81 = ((decoder_35 = Types_Alarm_get_Decoder(), (path_63) => ((value_98) => option_100(uncurry2(decoder_35), path_63, value_98)))), (objectArg_40 = get$.Optional, objectArg_40.Field("alarm", uncurry2(arg_81)))), undefined);
        const WriteAccess = defaultArg((objectArg_41 = get$.Optional, objectArg_41.Field("writeAccess", (path_65, value_101) => option_100(bool, path_65, value_101))), undefined);
        const LastCall = defaultArg((objectArg_42 = get$.Optional, objectArg_42.Field("lastCall", (path_67, value_104) => option_100(datetime, path_67, value_104))), undefined);
        const S1Calibration = defaultArg((arg_87 = ((decoder_38 = Types_Calibration_get_Decoder(), (path_68) => ((value_106) => option_100(uncurry2(decoder_38), path_68, value_106)))), (objectArg_43 = get$.Optional, objectArg_43.Field("s1Calibration", uncurry2(arg_87)))), undefined);
        const S2Calibration = defaultArg((arg_89 = ((decoder_39 = Types_Calibration_get_Decoder(), (path_69) => ((value_108) => option_100(uncurry2(decoder_39), path_69, value_108)))), (objectArg_44 = get$.Optional, objectArg_44.Field("s2Calibration", uncurry2(arg_89)))), undefined);
        const S3Calibration = defaultArg((arg_91 = ((decoder_40 = Types_Calibration_get_Decoder(), (path_70) => ((value_110) => option_100(uncurry2(decoder_40), path_70, value_110)))), (objectArg_45 = get$.Optional, objectArg_45.Field("s3Calibration", uncurry2(arg_91)))), undefined);
        const S4Calibration = defaultArg((arg_93 = ((decoder_41 = Types_Calibration_get_Decoder(), (path_71) => ((value_112) => option_100(uncurry2(decoder_41), path_71, value_112)))), (objectArg_46 = get$.Optional, objectArg_46.Field("s4Calibration", uncurry2(arg_93)))), undefined);
        const S5Calibration = defaultArg((arg_95 = ((decoder_42 = Types_Calibration_get_Decoder(), (path_72) => ((value_114) => option_100(uncurry2(decoder_42), path_72, value_114)))), (objectArg_47 = get$.Optional, objectArg_47.Field("s5Calibration", uncurry2(arg_95)))), undefined);
        const S6Calibration = defaultArg((arg_97 = ((decoder_43 = Types_Calibration_get_Decoder(), (path_73) => ((value_116) => option_100(uncurry2(decoder_43), path_73, value_116)))), (objectArg_48 = get$.Optional, objectArg_48.Field("s6Calibration", uncurry2(arg_97)))), undefined);
        const S7Calibration = defaultArg((arg_99 = ((decoder_44 = Types_Calibration_get_Decoder(), (path_74) => ((value_118) => option_100(uncurry2(decoder_44), path_74, value_118)))), (objectArg_49 = get$.Optional, objectArg_49.Field("s7Calibration", uncurry2(arg_99)))), undefined);
        const S8Calibration = defaultArg((arg_101 = ((decoder_45 = Types_Calibration_get_Decoder(), (path_75) => ((value_120) => option_100(uncurry2(decoder_45), path_75, value_120)))), (objectArg_50 = get$.Optional, objectArg_50.Field("s8Calibration", uncurry2(arg_101)))), undefined);
        const S9Calibration = defaultArg((arg_103 = ((decoder_46 = Types_Calibration_get_Decoder(), (path_76) => ((value_122) => option_100(uncurry2(decoder_46), path_76, value_122)))), (objectArg_51 = get$.Optional, objectArg_51.Field("s9Calibration", uncurry2(arg_103)))), undefined);
        const S10Calibration = defaultArg((arg_105 = ((decoder_47 = Types_Calibration_get_Decoder(), (path_77) => ((value_124) => option_100(uncurry2(decoder_47), path_77, value_124)))), (objectArg_52 = get$.Optional, objectArg_52.Field("s10Calibration", uncurry2(arg_105)))), undefined);
        const S1Interpolation = defaultArg((arg_107 = ((decoder_48 = Types_Interpolation_get_Decoder(), (path_78) => ((value_126) => option_100(uncurry2(decoder_48), path_78, value_126)))), (objectArg_53 = get$.Optional, objectArg_53.Field("s1Interpolation", uncurry2(arg_107)))), undefined);
        const S2Interpolation = defaultArg((arg_109 = ((decoder_49 = Types_Interpolation_get_Decoder(), (path_79) => ((value_128) => option_100(uncurry2(decoder_49), path_79, value_128)))), (objectArg_54 = get$.Optional, objectArg_54.Field("s2Interpolation", uncurry2(arg_109)))), undefined);
        const S3Interpolation = defaultArg((arg_111 = ((decoder_50 = Types_Interpolation_get_Decoder(), (path_80) => ((value_130) => option_100(uncurry2(decoder_50), path_80, value_130)))), (objectArg_55 = get$.Optional, objectArg_55.Field("s3Interpolation", uncurry2(arg_111)))), undefined);
        const S4Interpolation = defaultArg((arg_113 = ((decoder_51 = Types_Interpolation_get_Decoder(), (path_81) => ((value_132) => option_100(uncurry2(decoder_51), path_81, value_132)))), (objectArg_56 = get$.Optional, objectArg_56.Field("s4Interpolation", uncurry2(arg_113)))), undefined);
        const S5Interpolation = defaultArg((arg_115 = ((decoder_52 = Types_Interpolation_get_Decoder(), (path_82) => ((value_134) => option_100(uncurry2(decoder_52), path_82, value_134)))), (objectArg_57 = get$.Optional, objectArg_57.Field("s5Interpolation", uncurry2(arg_115)))), undefined);
        const S6Interpolation = defaultArg((arg_117 = ((decoder_53 = Types_Interpolation_get_Decoder(), (path_83) => ((value_136) => option_100(uncurry2(decoder_53), path_83, value_136)))), (objectArg_58 = get$.Optional, objectArg_58.Field("s6Interpolation", uncurry2(arg_117)))), undefined);
        const S7Interpolation = defaultArg((arg_119 = ((decoder_54 = Types_Interpolation_get_Decoder(), (path_84) => ((value_138) => option_100(uncurry2(decoder_54), path_84, value_138)))), (objectArg_59 = get$.Optional, objectArg_59.Field("s7Interpolation", uncurry2(arg_119)))), undefined);
        const S8Interpolation = defaultArg((arg_121 = ((decoder_55 = Types_Interpolation_get_Decoder(), (path_85) => ((value_140) => option_100(uncurry2(decoder_55), path_85, value_140)))), (objectArg_60 = get$.Optional, objectArg_60.Field("s8Interpolation", uncurry2(arg_121)))), undefined);
        const S9Interpolation = defaultArg((arg_123 = ((decoder_56 = Types_Interpolation_get_Decoder(), (path_86) => ((value_142) => option_100(uncurry2(decoder_56), path_86, value_142)))), (objectArg_61 = get$.Optional, objectArg_61.Field("s9Interpolation", uncurry2(arg_123)))), undefined);
        const S10Interpolation = defaultArg((arg_125 = ((decoder_57 = Types_Interpolation_get_Decoder(), (path_87) => ((value_144) => option_100(uncurry2(decoder_57), path_87, value_144)))), (objectArg_62 = get$.Optional, objectArg_62.Field("s10Interpolation", uncurry2(arg_125)))), undefined);
        const S1Coeff = defaultArg((arg_127 = ((decoder_58 = Types_Coeff_get_Decoder(), (path_88) => ((value_146) => option_100(uncurry2(decoder_58), path_88, value_146)))), (objectArg_63 = get$.Optional, objectArg_63.Field("s1Coeff", uncurry2(arg_127)))), undefined);
        const S2Coeff = defaultArg((arg_129 = ((decoder_59 = Types_Coeff_get_Decoder(), (path_89) => ((value_148) => option_100(uncurry2(decoder_59), path_89, value_148)))), (objectArg_64 = get$.Optional, objectArg_64.Field("s2Coeff", uncurry2(arg_129)))), undefined);
        const S3Coeff = defaultArg((arg_131 = ((decoder_60 = Types_Coeff_get_Decoder(), (path_90) => ((value_150) => option_100(uncurry2(decoder_60), path_90, value_150)))), (objectArg_65 = get$.Optional, objectArg_65.Field("s3Coeff", uncurry2(arg_131)))), undefined);
        const S4Coeff = defaultArg((arg_133 = ((decoder_61 = Types_Coeff_get_Decoder(), (path_91) => ((value_152) => option_100(uncurry2(decoder_61), path_91, value_152)))), (objectArg_66 = get$.Optional, objectArg_66.Field("s4Coeff", uncurry2(arg_133)))), undefined);
        const S5Coeff = defaultArg((arg_135 = ((decoder_62 = Types_Coeff_get_Decoder(), (path_92) => ((value_154) => option_100(uncurry2(decoder_62), path_92, value_154)))), (objectArg_67 = get$.Optional, objectArg_67.Field("s5Coeff", uncurry2(arg_135)))), undefined);
        const S6Coeff = defaultArg((arg_137 = ((decoder_63 = Types_Coeff_get_Decoder(), (path_93) => ((value_156) => option_100(uncurry2(decoder_63), path_93, value_156)))), (objectArg_68 = get$.Optional, objectArg_68.Field("s6Coeff", uncurry2(arg_137)))), undefined);
        const S7Coeff = defaultArg((arg_139 = ((decoder_64 = Types_Coeff_get_Decoder(), (path_94) => ((value_158) => option_100(uncurry2(decoder_64), path_94, value_158)))), (objectArg_69 = get$.Optional, objectArg_69.Field("s7Coeff", uncurry2(arg_139)))), undefined);
        const S8Coeff = defaultArg((arg_141 = ((decoder_65 = Types_Coeff_get_Decoder(), (path_95) => ((value_160) => option_100(uncurry2(decoder_65), path_95, value_160)))), (objectArg_70 = get$.Optional, objectArg_70.Field("s8Coeff", uncurry2(arg_141)))), undefined);
        const S9Coeff = defaultArg((arg_143 = ((decoder_66 = Types_Coeff_get_Decoder(), (path_96) => ((value_162) => option_100(uncurry2(decoder_66), path_96, value_162)))), (objectArg_71 = get$.Optional, objectArg_71.Field("s9Coeff", uncurry2(arg_143)))), undefined);
        const S10Coeff = defaultArg((arg_145 = ((decoder_67 = Types_Coeff_get_Decoder(), (path_97) => ((value_164) => option_100(uncurry2(decoder_67), path_97, value_164)))), (objectArg_72 = get$.Optional, objectArg_72.Field("s10Coeff", uncurry2(arg_145)))), undefined);
        const S1CumulParameters = defaultArg((arg_147 = ((decoder_68 = Types_CumulParameters_get_Decoder(), (path_98) => ((value_166) => option_100(uncurry2(decoder_68), path_98, value_166)))), (objectArg_73 = get$.Optional, objectArg_73.Field("s1CumulParameters", uncurry2(arg_147)))), undefined);
        const S2CumulParameters = defaultArg((arg_149 = ((decoder_69 = Types_CumulParameters_get_Decoder(), (path_99) => ((value_168) => option_100(uncurry2(decoder_69), path_99, value_168)))), (objectArg_74 = get$.Optional, objectArg_74.Field("s2CumulParameters", uncurry2(arg_149)))), undefined);
        const S3CumulParameters = defaultArg((arg_151 = ((decoder_70 = Types_CumulParameters_get_Decoder(), (path_100) => ((value_170) => option_100(uncurry2(decoder_70), path_100, value_170)))), (objectArg_75 = get$.Optional, objectArg_75.Field("s3CumulParameters", uncurry2(arg_151)))), undefined);
        const S4CumulParameters = defaultArg((arg_153 = ((decoder_71 = Types_CumulParameters_get_Decoder(), (path_101) => ((value_172) => option_100(uncurry2(decoder_71), path_101, value_172)))), (objectArg_76 = get$.Optional, objectArg_76.Field("s4CumulParameters", uncurry2(arg_153)))), undefined);
        const S5CumulParameters = defaultArg((arg_155 = ((decoder_72 = Types_CumulParameters_get_Decoder(), (path_102) => ((value_174) => option_100(uncurry2(decoder_72), path_102, value_174)))), (objectArg_77 = get$.Optional, objectArg_77.Field("s5CumulParameters", uncurry2(arg_155)))), undefined);
        const S6CumulParameters = defaultArg((arg_157 = ((decoder_73 = Types_CumulParameters_get_Decoder(), (path_103) => ((value_176) => option_100(uncurry2(decoder_73), path_103, value_176)))), (objectArg_78 = get$.Optional, objectArg_78.Field("s6CumulParameters", uncurry2(arg_157)))), undefined);
        const S7CumulParameters = defaultArg((arg_159 = ((decoder_74 = Types_CumulParameters_get_Decoder(), (path_104) => ((value_178) => option_100(uncurry2(decoder_74), path_104, value_178)))), (objectArg_79 = get$.Optional, objectArg_79.Field("s7CumulParameters", uncurry2(arg_159)))), undefined);
        const S8CumulParameters = defaultArg((arg_161 = ((decoder_75 = Types_CumulParameters_get_Decoder(), (path_105) => ((value_180) => option_100(uncurry2(decoder_75), path_105, value_180)))), (objectArg_80 = get$.Optional, objectArg_80.Field("s8CumulParameters", uncurry2(arg_161)))), undefined);
        const S9CumulParameters = defaultArg((arg_163 = ((decoder_76 = Types_CumulParameters_get_Decoder(), (path_106) => ((value_182) => option_100(uncurry2(decoder_76), path_106, value_182)))), (objectArg_81 = get$.Optional, objectArg_81.Field("s9CumulParameters", uncurry2(arg_163)))), undefined);
        const S10CumulParameters = defaultArg((arg_165 = ((decoder_77 = Types_CumulParameters_get_Decoder(), (path_107) => ((value_184) => option_100(uncurry2(decoder_77), path_107, value_184)))), (objectArg_82 = get$.Optional, objectArg_82.Field("s10CumulParameters", uncurry2(arg_165)))), undefined);
        const ShareKey = defaultArg((objectArg_83 = get$.Optional, objectArg_83.Field("shareKey", (path_109, value_187) => option_100(string, path_109, value_187))), undefined);
        const ShareCode = defaultArg((objectArg_84 = get$.Optional, objectArg_84.Field("shareCode", (path_111, value_190) => option_100(string, path_111, value_190))), undefined);
        const SharePass = defaultArg((objectArg_85 = get$.Optional, objectArg_85.Field("sharePass", (path_112, value_192) => option_100(uncurry2(int), path_112, value_192))), undefined);
        const Schedule = defaultArg((arg_173 = ((decoder_82 = ((decoder_81 = Types_ScheduleDay_get_Decoder(), (path_113) => ((value_194) => list_7(uncurry2(decoder_81), path_113, value_194)))), (path_114) => ((value_195) => option_100(uncurry2(decoder_82), path_114, value_195)))), (objectArg_86 = get$.Optional, objectArg_86.Field("schedule", uncurry2(arg_173)))), undefined);
        const SensorOptions = defaultArg((arg_175 = ((decoder_84 = ((decoder_83 = Types_SensorOption_get_Decoder(), (path_115) => ((value_197) => list_7(uncurry2(decoder_83), path_115, value_197)))), (path_116) => ((value_198) => option_100(uncurry2(decoder_84), path_116, value_198)))), (objectArg_87 = get$.Optional, objectArg_87.Field("sensorOptions", uncurry2(arg_175)))), undefined);
        const IsBackToWork = defaultArg((objectArg_88 = get$.Optional, objectArg_88.Field("isBackToWork", (path_118, value_201) => option_100(bool, path_118, value_201))), undefined);
        const ResumeWork = defaultArg((objectArg_89 = get$.Optional, objectArg_89.Field("resumeWork", (path_120, value_204) => option_100(bool, path_120, value_204))), undefined);
        const Birthday = defaultArg((objectArg_90 = get$.Optional, objectArg_90.Field("birthday", (path_122, value_207) => option_100(datetime, path_122, value_207))), undefined);
        const EndOfLife = defaultArg((objectArg_91 = get$.Optional, objectArg_91.Field("endOfLife", (path_123, value_209) => option_100(uncurry2(int), path_123, value_209))), undefined);
        const Cumulated = defaultArg((objectArg_92 = get$.Optional, objectArg_92.Field("cumulated", (path_125, value_212) => option_100(bool, path_125, value_212))), undefined);
        const TwimmCall = defaultArg((objectArg_93 = get$.Optional, objectArg_93.Field("twimmOutboundCall", (path_127, value_215) => option_100(string, path_127, value_215))), undefined);
        const TwimmToken = defaultArg((objectArg_94 = get$.Optional, objectArg_94.Field("twimmToken", (path_129, value_218) => option_100(string, path_129, value_218))), undefined);
        const VAKind = defaultArg((objectArg_95 = get$.Optional, objectArg_95.Field("VAKind", (path_130, value_220) => option_100(uncurry2(int), path_130, value_220))), undefined);
        const EtalonLDC = defaultArg((objectArg_96 = get$.Optional, objectArg_96.Field("EtalonLDC", (path_132, value_223) => option_100(bool, path_132, value_223))), undefined);
        const Ldcv = defaultArg((objectArg_97 = get$.Optional, objectArg_97.Field("ldcv2", (path_134, value_226) => option_100(bool, path_134, value_226))), undefined);
        const CheckPowerLoss = defaultArg((objectArg_98 = get$.Optional, objectArg_98.Field("CheckPowerLoss", (path_136, value_229) => option_100(bool, path_136, value_229))), undefined);
        return new Types_Full(Id, Deleted, Rev, DocKind, SensorKind, Name, Contract, Title, S, S_1, S_2, S_3, S_4, S_5, S_6, S_7, S_8, S_9, S1Title, S2Title, S3Title, S4Title, S5Title, S6Title, S7Title, S8Title, S9Title, S10Title, S1Activated, S2Activated, S3Activated, S4Activated, S5Activated, S6Activated, S7Activated, S8Activated, S9Activated, S10Activated, S1Calibration, S2Calibration, S3Calibration, S4Calibration, S5Calibration, S6Calibration, S7Calibration, S8Calibration, S9Calibration, S10Calibration, S1Interpolation, S2Interpolation, S3Interpolation, S4Interpolation, S5Interpolation, S6Interpolation, S7Interpolation, S8Interpolation, S9Interpolation, S10Interpolation, S1Coeff, S2Coeff, S3Coeff, S4Coeff, S5Coeff, S6Coeff, S7Coeff, S8Coeff, S9Coeff, S10Coeff, S1CumulParameters, S2CumulParameters, S3CumulParameters, S4CumulParameters, S5CumulParameters, S6CumulParameters, S7CumulParameters, S8CumulParameters, S9CumulParameters, S10CumulParameters, OwnerWeb, OwnerName, Alarm, WriteAccess, LastCall, ShareKey, ShareCode, SharePass, Schedule, SensorOptions, IsBackToWork, ResumeWork, Birthday, EndOfLife, Cumulated, TwimmCall, TwimmToken, VAKind, EtalonLDC, Ldcv, defaultArg((arg_199 = ((decoder_96 = Types_LoiDeChauffe_get_Decoder(), (path_137) => ((value_231) => option_100(uncurry2(decoder_96), path_137, value_231)))), (objectArg_99 = get$.Optional, objectArg_99.Field("loiDeChauffe", uncurry2(arg_199)))), undefined), CheckPowerLoss, defaultArg((objectArg_100 = get$.Optional, objectArg_100.Field("renewalInterval", (path_138, value_233) => option_100(uncurry2(int), path_138, value_233))), undefined), defaultArg((objectArg_101 = get$.Optional, objectArg_101.Field("checkedWeeks", (path_140, value_236) => option_100((path_139, value_235) => list_7(uncurry2(int), path_139, value_235), path_140, value_236))), undefined), defaultArg((objectArg_102 = get$.Optional, objectArg_102.Field("isBeta", (path_142, value_239) => option_100(bool, path_142, value_239))), undefined), defaultArg((objectArg_103 = get$.Optional, objectArg_103.Field("isDead", (path_144, value_242) => option_100(bool, path_144, value_242))), undefined), defaultArg((objectArg_104 = get$.Optional, objectArg_104.Field("tag", (path_146, value_245) => option_100(string, path_146, value_245))), undefined));
    }, path_147, v));
}

export function Types_SensorData_Empty(moduleId, kind) {
    return new Types_SensorData(moduleId, kind, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 0, 0);
}

export function Types_SensorData_Encode_Z81CA398(o) {
    return toString_3(0, object([["moduleId", o.ModuleId], ["sensorKind", toString_2(o.SensorKind)], ["s1", option_101((value_2) => value_2)(o.S1)], ["s2", option_101((value_4) => value_4)(o.S2)], ["s3", option_101((value_6) => value_6)(o.S3)], ["s4", option_101((value_8) => value_8)(o.S4)], ["s5", option_101((value_10) => value_10)(o.S5)], ["s6", option_101((value_12) => value_12)(o.S6)], ["s7", option_101((value_14) => value_14)(o.S7)], ["s8", option_101((value_16) => value_16)(o.S8)], ["s9", option_101((value_18) => value_18)(o.S9)], ["s10", option_101((value_20) => value_20)(o.S10)], ["battery", o.Battery], ["rssi", o.Rssi]]));
}

export function Types_SensorData_EncodeObject_Z81CA398(o) {
    return object([["moduleId", o.ModuleId], ["sensorKind", toString_2(o.SensorKind)], ["s1", option_101((value_2) => value_2)(o.S1)], ["s2", option_101((value_4) => value_4)(o.S2)], ["s3", option_101((value_6) => value_6)(o.S3)], ["s4", option_101((value_8) => value_8)(o.S4)], ["s5", option_101((value_10) => value_10)(o.S5)], ["s6", option_101((value_12) => value_12)(o.S6)], ["s7", option_101((value_14) => value_14)(o.S7)], ["s8", option_101((value_16) => value_16)(o.S8)], ["s9", option_101((value_18) => value_18)(o.S9)], ["s10", option_101((value_20) => value_20)(o.S10)], ["battery", o.Battery], ["rssi", o.Rssi]]);
}

export function Types_SensorData_get_Decoder() {
    return (path_23) => ((v) => object_1((get$) => {
        let objectArg, arg_3, objectArg_1, objectArg_2, objectArg_3, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8, objectArg_9, objectArg_10, objectArg_11, objectArg_12, objectArg_13;
        return new Types_SensorData((objectArg = get$.Required, objectArg.Field("moduleId", string)), (arg_3 = Types_SensorKind_get_decode(), (objectArg_1 = get$.Required, objectArg_1.Field("sensorKind", uncurry2(arg_3)))), defaultArg((objectArg_2 = get$.Optional, objectArg_2.Field("s1", (path_2, value_2) => option_100(float, path_2, value_2))), undefined), defaultArg((objectArg_3 = get$.Optional, objectArg_3.Field("s2", (path_4, value_5) => option_100(float, path_4, value_5))), undefined), defaultArg((objectArg_4 = get$.Optional, objectArg_4.Field("s3", (path_6, value_8) => option_100(float, path_6, value_8))), undefined), defaultArg((objectArg_5 = get$.Optional, objectArg_5.Field("s4", (path_8, value_11) => option_100(float, path_8, value_11))), undefined), defaultArg((objectArg_6 = get$.Optional, objectArg_6.Field("s5", (path_10, value_14) => option_100(float, path_10, value_14))), undefined), defaultArg((objectArg_7 = get$.Optional, objectArg_7.Field("s6", (path_12, value_17) => option_100(float, path_12, value_17))), undefined), defaultArg((objectArg_8 = get$.Optional, objectArg_8.Field("s7", (path_14, value_20) => option_100(float, path_14, value_20))), undefined), defaultArg((objectArg_9 = get$.Optional, objectArg_9.Field("s8", (path_16, value_23) => option_100(float, path_16, value_23))), undefined), defaultArg((objectArg_10 = get$.Optional, objectArg_10.Field("s9", (path_18, value_26) => option_100(float, path_18, value_26))), undefined), defaultArg((objectArg_11 = get$.Optional, objectArg_11.Field("s10", (path_20, value_29) => option_100(float, path_20, value_29))), undefined), (objectArg_12 = get$.Required, objectArg_12.Field("battery", float)), (objectArg_13 = get$.Required, objectArg_13.Field("rssi", float)));
    }, path_23, v));
}

export function Types_SensorData_ToAlarmsM32(writeToken, data, settings) {
    let arg_4, arg_5;
    const alarm = (i, value) => toText(printf("NEWGTS \'alarm.s1\' RENAME { \'id\' $id } RELABEL $ts%i NaN NaN NaN %f ADDVALUE"))(i)(value);
    const check = (data_1, settings_1, name, list) => {
        let matchResult, settings_2, value_1;
        if (data_1 != null) {
            if (settings_1 != null) {
                matchResult = 0;
                settings_2 = settings_1;
                value_1 = data_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const matchValue_1 = settings_2.Min;
                const matchValue_2 = settings_2.Max;
                if (matchValue_1 == null) {
                    if (matchValue_2 == null) {
                        return list;
                    }
                    else {
                        const max_1 = matchValue_2;
                        if (value_1 > max_1) {
                            return append(list, singleton(alarm(name, value_1)));
                        }
                        else {
                            return list;
                        }
                    }
                }
                else if (matchValue_2 == null) {
                    const min_1 = matchValue_1;
                    if (value_1 < min_1) {
                        return append(list, singleton(alarm(name, value_1)));
                    }
                    else {
                        return list;
                    }
                }
                else {
                    const max = matchValue_2;
                    const min = matchValue_1;
                    if (value_1 > max) {
                        return append(list, singleton(alarm(name, value_1)));
                    }
                    else if (value_1 < min) {
                        return append(list, singleton(alarm(name, value_1)));
                    }
                    else {
                        return list;
                    }
                }
            }
            default:
                return list;
        }
    };
    const list_1 = check(data.S4, settings.S4, 4, check(data.S3, settings.S3, 3, check(data.S2, settings.S2, 2, check(data.S1, settings.S1, 1, empty()))));
    if (length(list_1) > 0) {
        return (arg_4 = join(" ", list_1), (arg_5 = (length(list_1) | 0), toText(printf("\n              \'%s\' \'id\' STORE\n              NOW 18 h - \'ts1\' STORE\n              NOW 12 h - \'ts2\' STORE\n              NOW 6 h - \'ts3\' STORE\n              NOW \'ts4\' STORE\n              \'%s\' \'token\' STORE\n              %s\n              %i ->LIST\n              $token UPDATE\n          "))(data.ModuleId)(writeToken)(arg_4)(arg_5)));
    }
    else {
        return undefined;
    }
}

export function Types_SensorData_ToAlarms(data, settings) {
    const check = (data_1, settings_1, list) => {
        let matchResult, settings_2, value;
        if (data_1 != null) {
            if (settings_1 != null) {
                matchResult = 0;
                settings_2 = settings_1;
                value = data_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const matchValue_1 = settings_2.Min;
                const matchValue_2 = settings_2.Max;
                if (matchValue_1 == null) {
                    if (matchValue_2 == null) {
                        return list;
                    }
                    else {
                        const max_1 = matchValue_2;
                        if (value > max_1) {
                            return append(list, singleton(true));
                        }
                        else {
                            return list;
                        }
                    }
                }
                else if (matchValue_2 == null) {
                    const min_1 = matchValue_1;
                    if (value < min_1) {
                        return append(list, singleton(true));
                    }
                    else {
                        return list;
                    }
                }
                else {
                    const max = matchValue_2;
                    const min = matchValue_1;
                    if (value > max) {
                        return append(list, singleton(true));
                    }
                    else if (value < min) {
                        return append(list, singleton(true));
                    }
                    else {
                        return list;
                    }
                }
            }
            default:
                return list;
        }
    };
    return length(check(data.Battery, settings.Battery, check(data.S10, settings.S10, check(data.S9, settings.S9, check(data.S8, settings.S8, check(data.S7, settings.S7, check(data.S6, settings.S6, check(data.S5, settings.S5, check(data.S4, settings.S4, check(data.S3, settings.S3, check(data.S2, settings.S2, check(data.S1, settings.S1, empty())))))))))))) > 0;
}

export function Types_SensorData_ToSeries(writeToken, data, sensor, time) {
    let ts;
    if (time == null) {
        ts = "NOW";
    }
    else {
        const time_1 = time;
        ts = ((time_1.toLocaleLowerCase().indexOf("t") >= 0) ? "NOW" : toText(printf("%s"))(time_1));
    }
    const matchValue = data.S1;
    const matchValue_1 = data.S2;
    const matchValue_2 = data.S3;
    const matchValue_3 = data.S4;
    const matchValue_4 = data.S5;
    const matchValue_5 = data.S6;
    const matchValue_6 = data.S7;
    const matchValue_7 = data.S8;
    const matchValue_8 = data.S9;
    const matchValue_9 = data.S10;
    let matchResult, S1, S1_1, S2, S1_2, S2_1, S3, S1_3, S2_2, S3_1, S4, S1_4, S2_3, S3_2, S4_1, S5, S1_5, S2_4, S3_3, S4_2, S5_1, S6, S1_6, S2_5, S3_4, S4_3, S5_2, S6_1, S7, S1_7, S2_6, S3_5, S4_4, S5_3, S6_2, S7_1, S8, S1_8, S2_7, S3_6, S4_5, S5_4, S6_3, S7_2, S8_1, S9, S1_9, S2_8, S3_7, S4_6, S5_5, S6_4, S7_3, S8_2, S9_1, s10;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            if (matchValue_2 != null) {
                if (matchValue_3 != null) {
                    if (matchValue_4 != null) {
                        if (matchValue_5 != null) {
                            if (matchValue_6 != null) {
                                if (matchValue_7 != null) {
                                    if (matchValue_8 != null) {
                                        if (matchValue_9 != null) {
                                            matchResult = 9;
                                            S1_9 = matchValue;
                                            S2_8 = matchValue_1;
                                            S3_7 = matchValue_2;
                                            S4_6 = matchValue_3;
                                            S5_5 = matchValue_4;
                                            S6_4 = matchValue_5;
                                            S7_3 = matchValue_6;
                                            S8_2 = matchValue_7;
                                            S9_1 = matchValue_8;
                                            s10 = matchValue_9;
                                        }
                                        else {
                                            matchResult = 8;
                                            S1_8 = matchValue;
                                            S2_7 = matchValue_1;
                                            S3_6 = matchValue_2;
                                            S4_5 = matchValue_3;
                                            S5_4 = matchValue_4;
                                            S6_3 = matchValue_5;
                                            S7_2 = matchValue_6;
                                            S8_1 = matchValue_7;
                                            S9 = matchValue_8;
                                        }
                                    }
                                    else if (matchValue_9 == null) {
                                        matchResult = 7;
                                        S1_7 = matchValue;
                                        S2_6 = matchValue_1;
                                        S3_5 = matchValue_2;
                                        S4_4 = matchValue_3;
                                        S5_3 = matchValue_4;
                                        S6_2 = matchValue_5;
                                        S7_1 = matchValue_6;
                                        S8 = matchValue_7;
                                    }
                                    else {
                                        matchResult = 10;
                                    }
                                }
                                else if (matchValue_8 == null) {
                                    if (matchValue_9 == null) {
                                        matchResult = 6;
                                        S1_6 = matchValue;
                                        S2_5 = matchValue_1;
                                        S3_4 = matchValue_2;
                                        S4_3 = matchValue_3;
                                        S5_2 = matchValue_4;
                                        S6_1 = matchValue_5;
                                        S7 = matchValue_6;
                                    }
                                    else {
                                        matchResult = 10;
                                    }
                                }
                                else {
                                    matchResult = 10;
                                }
                            }
                            else if (matchValue_7 == null) {
                                if (matchValue_8 == null) {
                                    if (matchValue_9 == null) {
                                        matchResult = 5;
                                        S1_5 = matchValue;
                                        S2_4 = matchValue_1;
                                        S3_3 = matchValue_2;
                                        S4_2 = matchValue_3;
                                        S5_1 = matchValue_4;
                                        S6 = matchValue_5;
                                    }
                                    else {
                                        matchResult = 10;
                                    }
                                }
                                else {
                                    matchResult = 10;
                                }
                            }
                            else {
                                matchResult = 10;
                            }
                        }
                        else if (matchValue_6 == null) {
                            if (matchValue_7 == null) {
                                if (matchValue_8 == null) {
                                    if (matchValue_9 == null) {
                                        matchResult = 4;
                                        S1_4 = matchValue;
                                        S2_3 = matchValue_1;
                                        S3_2 = matchValue_2;
                                        S4_1 = matchValue_3;
                                        S5 = matchValue_4;
                                    }
                                    else {
                                        matchResult = 10;
                                    }
                                }
                                else {
                                    matchResult = 10;
                                }
                            }
                            else {
                                matchResult = 10;
                            }
                        }
                        else {
                            matchResult = 10;
                        }
                    }
                    else if (matchValue_5 == null) {
                        if (matchValue_6 == null) {
                            if (matchValue_7 == null) {
                                if (matchValue_8 == null) {
                                    if (matchValue_9 == null) {
                                        matchResult = 3;
                                        S1_3 = matchValue;
                                        S2_2 = matchValue_1;
                                        S3_1 = matchValue_2;
                                        S4 = matchValue_3;
                                    }
                                    else {
                                        matchResult = 10;
                                    }
                                }
                                else {
                                    matchResult = 10;
                                }
                            }
                            else {
                                matchResult = 10;
                            }
                        }
                        else {
                            matchResult = 10;
                        }
                    }
                    else {
                        matchResult = 10;
                    }
                }
                else if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        if (matchValue_6 == null) {
                            if (matchValue_7 == null) {
                                if (matchValue_8 == null) {
                                    if (matchValue_9 == null) {
                                        matchResult = 2;
                                        S1_2 = matchValue;
                                        S2_1 = matchValue_1;
                                        S3 = matchValue_2;
                                    }
                                    else {
                                        matchResult = 10;
                                    }
                                }
                                else {
                                    matchResult = 10;
                                }
                            }
                            else {
                                matchResult = 10;
                            }
                        }
                        else {
                            matchResult = 10;
                        }
                    }
                    else {
                        matchResult = 10;
                    }
                }
                else {
                    matchResult = 10;
                }
            }
            else if (matchValue_3 == null) {
                if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        if (matchValue_6 == null) {
                            if (matchValue_7 == null) {
                                if (matchValue_8 == null) {
                                    if (matchValue_9 == null) {
                                        matchResult = 1;
                                        S1_1 = matchValue;
                                        S2 = matchValue_1;
                                    }
                                    else {
                                        matchResult = 10;
                                    }
                                }
                                else {
                                    matchResult = 10;
                                }
                            }
                            else {
                                matchResult = 10;
                            }
                        }
                        else {
                            matchResult = 10;
                        }
                    }
                    else {
                        matchResult = 10;
                    }
                }
                else {
                    matchResult = 10;
                }
            }
            else {
                matchResult = 10;
            }
        }
        else if (matchValue_2 == null) {
            if (matchValue_3 == null) {
                if (matchValue_4 == null) {
                    if (matchValue_5 == null) {
                        if (matchValue_6 == null) {
                            if (matchValue_7 == null) {
                                if (matchValue_8 == null) {
                                    if (matchValue_9 == null) {
                                        matchResult = 0;
                                        S1 = matchValue;
                                    }
                                    else {
                                        matchResult = 10;
                                    }
                                }
                                else {
                                    matchResult = 10;
                                }
                            }
                            else {
                                matchResult = 10;
                            }
                        }
                        else {
                            matchResult = 10;
                        }
                    }
                    else {
                        matchResult = 10;
                    }
                }
                else {
                    matchResult = 10;
                }
            }
            else {
                matchResult = 10;
            }
        }
        else {
            matchResult = 10;
        }
    }
    else {
        matchResult = 10;
    }
    switch (matchResult) {
        case 0:
            return toText(printf("\n          \'%s\' \'id\' STORE\n          %s \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          3 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(ts)(S1)(data.Battery)(data.Rssi)(writeToken);
        case 1:
            return toText(printf("\n          \'%s\' \'id\' STORE\n          %s \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'s2\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.s2\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s2 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          4 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(ts)(S1_1)(S2)(data.Battery)(data.Rssi)(writeToken);
        case 2:
            return toText(printf("\n          \'%s\' \'id\' STORE\n          %s \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'s2\' STORE\n          %f \'s3\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.s2\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s2 ADDVALUE\n          NEWGTS \'sensor.s3\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s3 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          5 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(ts)(S1_2)(S2_1)(S3)(data.Battery)(data.Rssi)(writeToken);
        case 3:
            return toText(printf("\n          \'%s\' \'id\' STORE\n          %s \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'s2\' STORE\n          %f \'s3\' STORE\n          %f \'s4\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.s2\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s2 ADDVALUE\n          NEWGTS \'sensor.s3\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s3 ADDVALUE\n          NEWGTS \'sensor.s4\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s4 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          6 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(ts)(S1_3)(S2_2)(S3_1)(S4)(data.Battery)(data.Rssi)(writeToken);
        case 4:
            return toText(printf("\n          \'%s\' \'id\' STORE\n          %s \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'s2\' STORE\n          %f \'s3\' STORE\n          %f \'s4\' STORE\n          %f \'s5\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.s2\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s2 ADDVALUE\n          NEWGTS \'sensor.s3\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s3 ADDVALUE\n          NEWGTS \'sensor.s4\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s4 ADDVALUE\n          NEWGTS \'sensor.s5\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s5 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          7 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(ts)(S1_4)(S2_3)(S3_2)(S4_1)(S5)(data.Battery)(data.Rssi)(writeToken);
        case 5:
            return toText(printf("\n          \'%s\' \'id\' STORE\n          %s \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'s2\' STORE\n          %f \'s3\' STORE\n          %f \'s4\' STORE\n          %f \'s5\' STORE\n          %f \'s6\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.s2\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s2 ADDVALUE\n          NEWGTS \'sensor.s3\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s3 ADDVALUE\n          NEWGTS \'sensor.s4\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s4 ADDVALUE\n          NEWGTS \'sensor.s5\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s5 ADDVALUE\n          NEWGTS \'sensor.s6\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s6 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          8 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(ts)(S1_5)(S2_4)(S3_3)(S4_2)(S5_1)(S6)(data.Battery)(data.Rssi)(writeToken);
        case 6:
            return toText(printf("\n          \'%s\' \'id\' STORE\n          %s \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'s2\' STORE\n          %f \'s3\' STORE\n          %f \'s4\' STORE\n          %f \'s5\' STORE\n          %f \'s6\' STORE\n          %f \'s7\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.s2\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s2 ADDVALUE\n          NEWGTS \'sensor.s3\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s3 ADDVALUE\n          NEWGTS \'sensor.s4\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s4 ADDVALUE\n          NEWGTS \'sensor.s5\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s5 ADDVALUE\n          NEWGTS \'sensor.s6\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s6 ADDVALUE\n          NEWGTS \'sensor.s7\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s7 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          9 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(ts)(S1_6)(S2_5)(S3_4)(S4_3)(S5_2)(S6_1)(S7)(data.Battery)(data.Rssi)(writeToken);
        case 7:
            return toText(printf("\n          \'%s\' \'id\' STORE\n          %s \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'s2\' STORE\n          %f \'s3\' STORE\n          %f \'s4\' STORE\n          %f \'s5\' STORE\n          %f \'s6\' STORE\n          %f \'s7\' STORE\n          %f \'s8\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.s2\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s2 ADDVALUE\n          NEWGTS \'sensor.s3\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s3 ADDVALUE\n          NEWGTS \'sensor.s4\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s4 ADDVALUE\n          NEWGTS \'sensor.s5\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s5 ADDVALUE\n          NEWGTS \'sensor.s6\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s6 ADDVALUE\n          NEWGTS \'sensor.s7\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s7 ADDVALUE\n          NEWGTS \'sensor.s8\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s8 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          10 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(ts)(S1_7)(S2_6)(S3_5)(S4_4)(S5_3)(S6_2)(S7_1)(S8)(data.Battery)(data.Rssi)(writeToken);
        case 8:
            return toText(printf("\n          \'%s\' \'id\' STORE\n          %s \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'s2\' STORE\n          %f \'s3\' STORE\n          %f \'s4\' STORE\n          %f \'s5\' STORE\n          %f \'s6\' STORE\n          %f \'s7\' STORE\n          %f \'s8\' STORE\n          %f \'s9\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.s2\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s2 ADDVALUE\n          NEWGTS \'sensor.s3\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s3 ADDVALUE\n          NEWGTS \'sensor.s4\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s4 ADDVALUE\n          NEWGTS \'sensor.s5\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s5 ADDVALUE\n          NEWGTS \'sensor.s6\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s6 ADDVALUE\n          NEWGTS \'sensor.s7\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s7 ADDVALUE\n          NEWGTS \'sensor.s8\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s8 ADDVALUE\n          NEWGTS \'sensor.s9\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s9 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          11 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(ts)(S1_8)(S2_7)(S3_6)(S4_5)(S5_4)(S6_3)(S7_2)(S8_1)(S9)(data.Battery)(data.Rssi)(writeToken);
        case 9:
            return toText(printf("\n          \'%s\' \'id\' STORE\n          %s \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'s2\' STORE\n          %f \'s3\' STORE\n          %f \'s4\' STORE\n          %f \'s5\' STORE\n          %f \'s6\' STORE\n          %f \'s7\' STORE\n          %f \'s8\' STORE\n          %f \'s9\' STORE\n          %f \'s10\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.s2\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s2 ADDVALUE\n          NEWGTS \'sensor.s3\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s3 ADDVALUE\n          NEWGTS \'sensor.s4\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s4 ADDVALUE\n          NEWGTS \'sensor.s5\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s5 ADDVALUE\n          NEWGTS \'sensor.s6\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s6 ADDVALUE\n          NEWGTS \'sensor.s7\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s7 ADDVALUE\n          NEWGTS \'sensor.s8\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s8 ADDVALUE\n          NEWGTS \'sensor.s9\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s9 ADDVALUE\n          NEWGTS \'sensor.s10\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s10 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          12 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(ts)(S1_9)(S2_8)(S3_7)(S4_6)(S5_5)(S6_4)(S7_3)(S8_2)(S9_1)(s10)(data.Battery)(data.Rssi)(writeToken);
        default:
            throw new Error(toText(printf("unhandled case for serie S1=%A S2=%A S3=%A S4=%A. should be 1 / 1,1 / 1,2,3 / 1,2,3,4"))(data.S1)(data.S2)(data.S3)(data.S4));
    }
}

export function Types_SensorData_toM32(writeToken, data, sensor) {
    const getValue = (baseValue, calibration) => {
        if (calibration == null) {
            return baseValue;
        }
        else {
            const c = calibration;
            if (c.Operation.tag === 1) {
                return baseValue - c.Value;
            }
            else {
                return baseValue + c.Value;
            }
        }
    };
    const matchValue_1 = data.S1;
    const matchValue_2 = data.S2;
    const matchValue_3 = data.S3;
    const matchValue_4 = data.S4;
    let matchResult, S4, S1, S2, S3, S4_2;
    if (matchValue_1 != null) {
        if (matchValue_2 != null) {
            if (matchValue_3 != null) {
                if (matchValue_4 != null) {
                    matchResult = 1;
                    S1 = matchValue_1;
                    S2 = matchValue_2;
                    S3 = matchValue_3;
                    S4_2 = matchValue_4;
                }
                else {
                    matchResult = 2;
                }
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else if (matchValue_2 == null) {
        if (matchValue_3 == null) {
            if (matchValue_4 != null) {
                matchResult = 0;
                S4 = matchValue_4;
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            const S4_1 = getValue(S4, sensor.S4Calibration);
            return toText(printf("\n          \'%s\' \'id\' STORE\n          NOW \'ts\' STORE\n          %f \'s1\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts NaN NaN NaN $rssi ADDVALUE\n          3 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(S4_1)(data.Battery)(data.Rssi)(writeToken);
        }
        case 1: {
            const calibration_1 = sensor.S4Calibration;
            const S1_1 = getValue(S1, calibration_1);
            const S2_1 = getValue(S2, calibration_1);
            const S3_1 = getValue(S3, calibration_1);
            const S4_3 = getValue(S4_2, calibration_1);
            return toText(printf("\n          \'%s\' \'id\' STORE\n          NOW 18 h - \'ts1\' STORE\n          NOW 12 h - \'ts2\' STORE\n          NOW 6 h - \'ts3\' STORE\n          NOW \'ts4\' STORE\n          %f \'s1\' STORE\n          %f \'s2\' STORE\n          %f \'s3\' STORE\n          %f \'s4\' STORE\n          %f \'battery\' STORE\n          %f \'rssi\' STORE\n          \'%s\' \'token\' STORE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts1 NaN NaN NaN $s1 ADDVALUE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts2 NaN NaN NaN $s2 ADDVALUE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts3 NaN NaN NaN $s3 ADDVALUE\n          NEWGTS \'sensor.s1\' RENAME { \'id\' $id } RELABEL $ts4 NaN NaN NaN $s4 ADDVALUE\n          NEWGTS \'sensor.battery\' RENAME { \'id\' $id } RELABEL $ts4 NaN NaN NaN $battery ADDVALUE\n          NEWGTS \'sensor.rssi\' RENAME { \'id\' $id } RELABEL $ts4 NaN NaN NaN $rssi ADDVALUE\n          6 ->LIST\n          $token UPDATE\n        "))(data.ModuleId)(S1_1)(S2_1)(S3_1)(S4_3)(data.Battery)(data.Rssi)(writeToken);
        }
        default:
            throw new Error(toText(printf("unhandled case for M32 S1=%A S2=%A S3=%A S4=%A. should be S4 only or all"))(data.S1)(data.S2)(data.S3)(data.S4));
    }
}

